// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.invd {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .invd {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .invd {
    padding: 16px 16px 28px;
  }
}

.invd-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
  flex-wrap: wrap;
}
.invd-breadcrumb li {
  display: flex;
  align-items: center;
}
.invd-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.invd-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.invd-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.invd-breadcrumb li.is-current {
  color: #6d6e71;
  font-weight: 600;
}

.invd-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}
@media (max-width: 640px) {
  .invd-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.invd-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  min-width: 0;
}

.invd-title {
  font-size: 26px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
  min-width: 0;
  max-width: 42ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 640px) {
  .invd-title {
    font-size: 21px;
  }
}

.invd-header__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.invd-status-wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  flex-shrink: 0;
}
.invd-status-wrap i {
  font-size: 10px;
  pointer-events: none;
  opacity: 0.8;
}

.invd-status {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  outline: none;
}

.invd-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background: #fff;
  color: #676a6c;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  white-space: nowrap;
}
.invd-btn[disabled], .invd-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}
.invd-btn:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
.invd-btn--danger:hover {
  background: rgba(245, 67, 89, 0.06);
  border-color: rgba(245, 67, 89, 0.3);
  color: rgb(245, 67, 89);
}
.invd-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.invd-btn--primary:hover {
  background: #569c21;
  border-color: #569c21;
}
.invd-btn--blue {
  background: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
}
.invd-btn--blue:hover {
  background: #008ba7;
  border-color: #008ba7;
}
.invd-btn--unlock {
  background: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
}
.invd-btn--unlock:hover {
  background: #008ba7;
  border-color: #008ba7;
}
.invd-btn--ghost {
  background: none;
  border-color: transparent;
  color: rgb(0, 173, 208);
}
.invd-btn--ghost:hover {
  background: rgba(0, 173, 208, 0.06);
  border-color: transparent;
  color: rgb(0, 173, 208);
}

.invd-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.invd-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.invd-card__title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
}

.invd-activity__lead {
  margin: 0 0 8px;
  font-size: 13px;
  color: #676a6c;
  line-height: 1.55;
  max-width: 620px;
}
.invd-activity__note {
  margin: 0 0 18px;
  padding: 10px 14px;
  font-size: 12px;
  color: #6d6e71;
  line-height: 1.6;
  max-width: 620px;
  background: rgba(0, 173, 208, 0.06);
  border: 1px solid rgba(0, 173, 208, 0.22);
  border-radius: 6px;
}
.invd-activity__note strong {
  font-weight: 700;
  color: #006174;
}
.invd-activity__board {
  margin-top: 4px;
}
.invd-activity__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e7eaec;
}
@media (max-width: 640px) {
  .invd-activity__toolbar {
    gap: 6px;
  }
}
.invd-activity__meta {
  font-size: 12px;
  color: #6d6e71;
  white-space: nowrap;
}
.invd-activity__gap {
  flex: 1;
}

.invd-activity__cta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 4px;
}

.invd-elig {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #6d6e71;
  background: rgba(255, 121, 0, 0.08);
  border: 1px solid rgba(255, 121, 0, 0.25);
  white-space: nowrap;
}
.invd-elig .fa {
  font-size: 13px;
  color: #c25c00;
}
.invd-elig strong {
  font-weight: 700;
  color: #a34d00;
}
.invd-elig.is-ready {
  background: rgba(105, 190, 40, 0.09);
  border-color: rgba(105, 190, 40, 0.3);
}
.invd-elig.is-ready .fa {
  color: #4d8b1d;
}
.invd-elig.is-ready strong {
  color: #3f7218;
}
@media (max-width: 480px) {
  .invd-elig {
    white-space: normal;
  }
}

.invd-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 20px;
}
@media (max-width: 767px) {
  .invd-summary {
    grid-template-columns: repeat(2, 1fr);
  }
}

.invd-summary--more {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e7eaec;
}

.invd-kv__k {
  display: block;
  color: #ccc;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 3px;
}

.invd-kv__v {
  font-size: 13px;
  color: #676a6c;
}

.invd-alink-btn .fa {
  color: rgb(0, 173, 208);
}

.invd-soon {
  font-size: 9px;
  background: #f1f1f2;
  border-radius: 8px;
  padding: 1px 5px;
  font-style: normal;
  color: #8a9099;
}

.invd-keychip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: 1px solid transparent;
  border-radius: 6px;
  background: rgba(105, 190, 40, 0.12);
  color: #4d8b1d;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.invd-keychip:hover {
  background: rgba(105, 190, 40, 0.2);
  border-color: rgba(105, 190, 40, 0.5);
}
.invd-keychip:focus-visible {
  outline: 2px solid rgb(105, 190, 40);
  outline-offset: 1px;
}
.invd-keychip--warn {
  background: rgba(245, 67, 89, 0.1);
  color: rgb(245, 67, 89);
}
.invd-keychip--warn:hover {
  background: rgba(245, 67, 89, 0.18);
  border-color: rgba(245, 67, 89, 0.5);
}
.invd-keychip--warn:focus-visible {
  outline-color: rgb(245, 67, 89);
}
.invd-keychip__n {
  font-weight: 700;
}
.invd-keychip__msg {
  font-weight: 500;
  opacity: 0.9;
}
.invd-keychip__plus {
  font-size: 10px;
  opacity: 0.7;
  margin-left: 1px;
}

.invkm {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .invkm {
    padding-left: 240px;
  }
}
.invkm__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.invkm__card {
  position: relative;
  z-index: 1;
  width: min(500px, 100%);
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.invkm__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}
.invkm__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.invkm__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.invkm__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.invkm__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.invkm__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}
.invkm__body {
  padding: 20px;
  overflow-y: auto;
}
.invkm__section {
  font-size: 13px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0 0 14px;
}
.invkm__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e7eaec;
}

.invkm-field {
  margin-bottom: 16px;
}
.invkm-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
}
.invkm-field .form-control {
  width: 100%;
  padding: 9px 12px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.invkm-field .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}

.invkm-field select.form-control {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 34px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23949699' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
}

.invkm-error {
  margin-top: 5px;
  font-size: 11.5px;
  line-height: 1.4;
  color: rgb(245, 67, 89);
}

.invkm-hint {
  margin: 5px 0 0;
  font-size: 11.5px;
  line-height: 1.4;
  color: #ccc;
}

.invkm-req {
  color: rgb(245, 67, 89);
}

.invkm-readonly {
  background: #f1f1f2 !important;
  color: #ccc;
}

.invkm-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 4px;
}

.invkm .fsc__list {
  max-height: 170px;
}

.invkm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invkm-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
}
.invkm-btn--primary:hover {
  background: #569c21;
}
.invkm-btn--primary[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.invkm-btn--purchase {
  background: rgb(0, 173, 208);
  color: #fff;
}
.invkm-btn--purchase:hover {
  background: #008ba7;
}
.invkm-btn--ghost {
  background: none;
  color: #ccc;
  border-color: transparent;
}
.invkm-btn--ghost:hover {
  color: #676a6c;
}

.invkm__header-icon--unlock {
  background: rgb(0, 173, 208);
}

.invkm__card--email {
  width: min(640px, 100%);
}

.invkm__header-icon--msg {
  background: rgb(0, 173, 208);
}

.invdm-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.invdm-bar label {
  margin-bottom: 0;
}

.invdm-tabs {
  display: inline-flex;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  overflow: hidden;
  background: #f1f1f2;
}

.invdm-tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #ccc;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invdm-tab + .invdm-tab {
  border-left: 1px solid #e7eaec;
}
.invdm-tab:hover {
  color: #676a6c;
}
.invdm-tab.is-active {
  background: #fff;
  color: rgb(0, 173, 208);
}

.invdm-body {
  min-height: 260px;
  resize: vertical;
  font-size: 13px;
  line-height: 1.55;
}

.invdm-preview {
  min-height: 260px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #f1f1f2;
  overflow-y: auto;
}
.invdm-preview__subject {
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 700;
  color: #6d6e71;
  border-bottom: 1px solid #e7eaec;
  background: #fff;
}
.invdm-preview pre {
  margin: 0;
  padding: 12px 14px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.55;
  color: #676a6c;
  white-space: pre-wrap;
  word-break: break-word;
  background: none;
  border: none;
}

.invdm-invalid {
  border-color: rgb(245, 67, 89) !important;
}

.invdm-error {
  margin-top: 6px;
  font-size: 12px;
  color: rgb(245, 67, 89);
}

.invum-summary {
  border: 1px solid #e7eaec;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 14px;
}

.invum-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 14px;
  font-size: 13px;
  color: #676a6c;
}
.invum-row + .invum-row {
  border-top: 1px solid #e7eaec;
}
.invum-row__val {
  font-weight: 700;
  color: #6d6e71;
}

.invum-warn {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  line-height: 1.45;
  background: rgba(255, 121, 0, 0.09);
  color: #cc6100;
  border: 1px solid rgba(255, 121, 0, 0.28);
}
.invum-warn .fa {
  margin-top: 1px;
}

.invd-tabs {
  display: flex;
  gap: 18px;
  align-items: center;
  flex-wrap: wrap;
}

.invd-tabs span {
  font-size: 13px;
  font-weight: 600;
  color: #ccc;
  cursor: pointer;
  padding-bottom: 6px;
  transition: color 0.15s ease;
}

.invd-tabs span:hover {
  color: #676a6c;
}

.invd-tabs .is-active {
  color: rgb(0, 173, 208);
  border-bottom: 2px solid rgb(0, 173, 208);
}

.invd-phead {
  flex-wrap: wrap;
  gap: 12px;
}

.invd-ptools {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.invd-ptitle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.invd-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: #f1f1f2;
  color: #ccc;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
}

.invd-iconbtn {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #ccc;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.18s ease;
}
.invd-iconbtn:hover {
  background: #f1f1f2;
  border-color: #ccc;
  color: #676a6c;
}
.invd-iconbtn.is-spinning i {
  animation: invd-spin 0.6s linear infinite;
}

@keyframes invd-spin {
  to {
    transform: rotate(360deg);
  }
}
.guide-modal {
  display: none;
}

.invd-dl {
  position: relative;
  display: inline-flex;
}
.invd-dl__caret {
  font-size: 11px;
  margin-left: 2px;
  transition: transform 0.15s ease;
}
.invd-dl.is-open .invd-dl__caret {
  transform: rotate(180deg);
}
.invd-dl__backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
}
.invd-dl__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 50;
  min-width: 220px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(0, 0, 0, 0.03);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.invd-dl__menu--right {
  left: auto;
  right: 0;
}
.invd-dl__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  text-align: left;
  transition: all 0.15s ease;
}
.invd-dl__item i {
  width: 16px;
  font-size: 13px;
  color: rgb(0, 173, 208);
}
.invd-dl__item:hover {
  background: rgba(0, 173, 208, 0.08);
  color: #6d6e71;
}

.invd-psearch {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.invd-psearch i {
  position: absolute;
  left: 10px;
  color: #ccc;
  font-size: 12px;
  pointer-events: none;
}
.invd-psearch input {
  height: 34px;
  box-sizing: border-box;
  padding: 7px 10px 7px 28px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 12px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  outline: none;
  min-width: 180px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.invd-psearch input:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}

.invd-num {
  text-align: center;
}

.invd-muted {
  color: #ccc;
}

.invd-lock {
  width: 28px;
  height: 22px;
  border: none;
  background: none;
  color: #6d6e71;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: color 0.15s ease;
}
.invd-lock:hover {
  color: #676a6c;
}

.invd-pactions {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.invd-paction {
  width: 26px;
  height: 26px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: transparent;
  color: #9aa0a6;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s ease;
}
.invd-paction:hover {
  background: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
  transform: scale(1.08);
}
.invd-paction.is-remove {
  font-size: 14px;
}
.invd-paction.is-remove:hover {
  background: rgb(245, 67, 89);
  color: #fff;
  border-color: rgb(245, 67, 89);
  box-shadow: 0 2px 8px rgba(245, 67, 89, 0.3);
}
.invd-paction.is-lock:hover {
  background: #c77700;
  color: #fff;
  border-color: #c77700;
}

.invd-remind {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 26px;
  padding: 0 11px;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 6px;
  background: rgb(105, 190, 40);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
}
.invd-remind i {
  font-size: 11px;
}
.invd-remind:hover {
  background: #569c21;
  border-color: #569c21;
}

.invd-ppager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e7eaec;
  flex-wrap: wrap;
}
.invd-ppager__info {
  font-size: 12px;
  color: #ccc;
}
.invd-ppager__ctrls {
  display: flex;
  gap: 4px;
}
.invd-ppager__btn {
  min-width: 28px;
  height: 28px;
  padding: 0 7px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invd-ppager__btn:hover:not(:disabled):not(.is-active) {
  background: #f1f1f2;
  border-color: #ccc;
}
.invd-ppager__btn.is-active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
.invd-ppager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.invd-ppager__left {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.invd-perpage {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  color: #ccc;
}
.invd-perpage select {
  padding: 4px 8px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 12px;
  color: #676a6c;
  cursor: pointer;
  outline: none;
}

.invd-check {
  width: 34px;
  text-align: center;
}

.invd-check input {
  cursor: pointer;
  margin: 0;
}

.invd-ptable tbody tr.is-selected {
  background: rgba(0, 173, 208, 0.06) !important;
}

.invd-bulk {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: rgba(0, 173, 208, 0.06);
  border: 1px solid rgba(0, 173, 208, 0.2);
  border-radius: 6px;
  font-size: 13px;
}
.invd-bulk__count {
  font-weight: 600;
  color: rgb(0, 173, 208);
}
.invd-bulk__hint {
  font-weight: 500;
  color: #ccc;
}
.invd-bulk__dl {
  margin-left: auto;
}
.invd-bulk .invd-btn {
  padding: 6px 12px;
  font-size: 12px;
}
.invd-bulk.is-empty {
  background: #f1f1f2;
  border-color: #e7eaec;
}

.invd-locked-txt {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #9e9e97;
  font-style: italic;
}
.invd-locked-txt i {
  font-size: 11px;
}

.invd-table {
  width: 100%;
  border-collapse: collapse;
}
.invd-table thead tr {
  background: #f1f1f2;
}
.invd-table thead th {
  padding: 10px 14px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  text-align: left;
  white-space: nowrap;
}
.invd-table tbody tr {
  border-bottom: 1px solid #e7eaec;
  transition: background-color 0.12s ease;
}
.invd-table tbody tr:hover {
  background: rgba(0, 173, 208, 0.03);
}
.invd-table tbody tr:last-child {
  border-bottom: none;
}
.invd-table tbody td {
  padding: 10px 14px;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle;
}

.invd-empty {
  text-align: center;
  color: #ccc;
  padding: 16px;
  font-size: 13px;
}

.invd-num-lock {
  color: #6d6e71;
  font-size: 11px;
}

.invd-progress {
  font-size: 12px;
  color: #9e9e97;
  font-style: italic;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.invd-started-txt {
  font-size: 12px;
  color: #9e9e97;
  font-style: italic;
  white-space: nowrap;
}

.invd-stagefilter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 14px;
}

.invd-stagefilter__sep {
  width: 1px;
  align-self: stretch;
  margin: 2px 2px;
  background: #e7eaec;
}

.invd-invite {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border: 1px solid #e7eaec;
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invd-invite i {
  font-size: 11px;
  color: #ccc;
}
.invd-invite:hover {
  border-color: #ccc;
  background: #f1f1f2;
}

.invd-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid #e7eaec;
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #ccc;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invd-chip__n {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #f1f1f2;
  color: #ccc;
  font-size: 11px;
  font-weight: 700;
}
.invd-chip:hover {
  border-color: #ccc;
  color: #676a6c;
}
.invd-chip.is-active {
  background: #6d6e71;
  border-color: #6d6e71;
  color: #fff;
}
.invd-chip.is-active .invd-chip__n {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.invd-divider {
  height: 1px;
  background: #e7eaec;
  margin: 18px 0 14px;
}

.invd-orgs-title {
  display: block;
  margin-bottom: 10px;
}

.invd-orgs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.invd-org-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 999px;
  padding: 3px 10px 3px 3px;
  font-size: 12px;
  color: #676a6c;
}
.invd-org-chip .inv-avatar {
  width: 22px;
  height: 22px;
  font-size: 8px;
}
.invd-org-chip__name {
  font-weight: 500;
  white-space: nowrap;
}
.invd-org-chip__pending {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #c77700;
  background: #fff4e5;
  border-radius: 999px;
  padding: 1px 7px;
  white-space: nowrap;
}
.invd-org-chip__act {
  border: none;
  background: none;
  color: #ccc;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  padding: 0;
  display: inline-flex;
  align-items: center;
  transition: color 0.15s ease;
}
.invd-org-chip__act:hover {
  color: rgb(0, 173, 208);
}
.invd-org-chip__remove {
  border: none;
  background: none;
  color: #ccc;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  padding: 0;
  display: inline-flex;
  align-items: center;
  transition: color 0.15s ease;
}
.invd-org-chip__remove:hover {
  color: rgb(245, 67, 89);
}
.invd-org-chip.is-pending {
  background: #fffaf2;
  border-color: #ffd9a8;
  border-style: dashed;
}

.invd-org-add {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(0, 173, 208, 0.06);
  border: 1px dashed rgba(0, 173, 208, 0.4);
  color: rgb(0, 173, 208);
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invd-org-add:hover {
  background: rgba(0, 173, 208, 0.12);
  border-style: solid;
}

.invd-link {
  color: rgb(0, 173, 208);
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.invd-link:hover {
  text-decoration: underline;
}

.invd-link--danger {
  color: rgb(245, 67, 89);
}

.invd-deferred {
  margin-top: 8px;
  font-size: 11px;
  color: #b0b4b8;
  border-top: 1px dashed #dde0e3;
  padding-top: 10px;
}

.inv-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  padding: 4px 11px;
  font-size: 12px;
  font-weight: 700;
  border: none;
}

.inv-pill--open {
  background: rgba(105, 190, 40, 0.12);
  color: #4d8b1d;
}

.inv-pill--closed {
  background: #f1f1f2;
  color: #8a9099;
}

.inv-avatar {
  display: inline-flex;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #00add0;
  color: #fff;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  flex-shrink: 0;
}

.inv-avatar.inv-avatar--grey {
  background: #e7eaec;
  color: #6d6e71;
}

.inv-avatar.inv-avatar--grey-lighter {
  background: #f1f1f2;
  color: #6d6e71;
}

.invem {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .invem {
    padding-left: 240px;
  }
}
.invem__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.invem__card {
  position: relative;
  z-index: 1;
  width: min(500px, 100%);
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.invem__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}
.invem__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.invem__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.invem__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.invem__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.invem__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}
.invem__body {
  padding: 20px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.6;
  color: #676a6c;
}
.invem__body p {
  margin: 0 0 14px;
}
.invem__intro {
  color: #ccc;
}
.invem__label {
  font-weight: 700;
  color: #6d6e71;
  margin-bottom: 2px !important;
}
.invem__val {
  margin-top: 0 !important;
}
.invem__links {
  margin: 0 0 14px;
  padding-left: 22px;
}
.invem__links li {
  margin-bottom: 4px;
}
.invem__links a {
  color: #6d6e71;
  text-decoration: underline;
}
.invem__links a:hover {
  color: rgb(0, 173, 208);
}
.invem__sign {
  margin-bottom: 0 !important;
}
.invem__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e7eaec;
}

.invgr {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .invgr {
    padding-left: 240px;
  }
}
.invgr__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.invgr__card {
  position: relative;
  z-index: 1;
  width: min(500px, 100%);
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.invgr__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}
.invgr__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.invgr__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.invgr__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.invgr__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.invgr__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}
.invgr__body {
  padding: 20px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.5;
  color: #676a6c;
}
.invgr__flabel {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
}
.invgr .form-control {
  width: 100%;
  padding: 9px 12px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  color: #676a6c;
  background: #fff;
  outline: none;
  margin-bottom: 14px;
}
.invgr .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.invgr__note {
  margin: 0 0 10px;
  color: #ccc;
  font-size: 13px;
}
.invgr__link {
  color: rgb(0, 173, 208);
  cursor: pointer;
  text-decoration: underline;
}
.invgr__tip {
  margin: 0 0 12px;
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
  color: #676a6c;
  background: rgba(0, 173, 208, 0.05);
  border: 1px solid rgba(0, 173, 208, 0.18);
}
.invgr__tip-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: #007a93;
  margin-bottom: 8px;
}
.invgr__tip-head .fa {
  font-size: 14px;
}
.invgr__tip-steps {
  margin: 0;
  padding-left: 18px;
}
.invgr__tip-steps li {
  margin-bottom: 6px;
}
.invgr__tip-steps li:last-child {
  margin-bottom: 0;
}
.invgr__tip-email {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 1px 7px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid rgba(0, 173, 208, 0.25);
  font-weight: 600;
  color: #6d6e71;
  white-space: nowrap;
}
.invgr__tip-copy {
  color: rgb(0, 173, 208);
  cursor: pointer;
  font-size: 11px;
  line-height: 1;
}
.invgr__tip-copy:hover {
  color: #00839d;
}
.invgr__section {
  font-size: 14px;
  font-weight: 700;
  color: #6d6e71;
  margin: 16px 0 8px;
}
.invgr__subnote {
  margin: 0 0 8px;
  color: #ccc;
  font-size: 13px;
}
.invgr__radio {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #676a6c;
  cursor: pointer;
}
.invgr__radio input {
  margin: 3px 0 0;
  flex-shrink: 0;
}
.invgr__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e7eaec;
  align-items: center;
}

.invwz {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 20px;
}
@media only screen and (min-width: 768px) {
  .invwz {
    padding-left: 240px;
  }
}
.invwz__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.invwz__card {
  position: relative;
  z-index: 1;
  width: min(680px, 100%);
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.invwz__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}
.invwz__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.invwz__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.invwz__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.invwz__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.invwz__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}
.invwz__body {
  padding: 20px;
  overflow-y: auto;
}
.invwz__footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e7eaec;
}
.invwz .form-control {
  width: 100%;
  padding: 9px 12px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  color: #676a6c;
  background: #fff;
  outline: none;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.invwz .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}

.invwz-steps {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 0 18px;
}

.invwz-step {
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 1;
  min-width: 0;
  color: #ccc;
  font-size: 12px;
  font-weight: 600;
}
.invwz-step:last-child {
  flex: 0 0 auto;
}
.invwz-step::after {
  content: "";
  flex: 1;
  height: 2px;
  min-width: 18px;
  margin: 0 12px;
  background: #eef0f1;
  border-radius: 2px;
}
.invwz-step:last-child::after {
  display: none;
}
.invwz-step.is-done::after {
  background: rgb(105, 190, 40);
}
.invwz-step__num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #eef0f1;
  color: #ccc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  transition: background 0.15s ease;
}
.invwz-step__label {
  white-space: nowrap;
}
.invwz-step.is-active {
  color: #1c84c6;
}
.invwz-step.is-active .invwz-step__num {
  background: #1c84c6;
  color: #fff;
}
.invwz-step.is-done .invwz-step__num {
  background: rgb(105, 190, 40);
  color: #fff;
}

.invwz .invkm-field {
  margin-bottom: 12px;
}

.invwz-intro {
  font-size: 13px;
  color: #ccc;
  margin: 0 0 14px;
}

.invwz-textarea {
  resize: vertical;
  line-height: 1.45;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
}

.invwz-gen {
  margin-bottom: 4px;
}

.invwz-hint {
  font-size: 12px;
  color: #ccc;
  margin: 0 0 12px;
}

.invwz-note {
  font-size: 13px;
  color: #676a6c;
  margin: 0 0 8px;
}

.invwz-or {
  font-size: 13px;
  font-weight: 700;
  color: #ccc;
  text-align: center;
  margin: 2px 0 10px;
}

.invwz-instr {
  margin: 0 0 14px;
  padding-left: 20px;
  font-size: 13px;
  color: #676a6c;
}
.invwz-instr li {
  margin-bottom: 4px;
}

.invwz-copyrow {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.invwz-copyrow .form-control {
  flex: 1;
}

.invwz-copybtn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: rgb(0, 173, 208);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s ease;
}
.invwz-copybtn:hover {
  background: rgba(0, 173, 208, 0.08);
  border-color: rgba(0, 173, 208, 0.3);
}

.sesb-badge {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 3px 9px;
  border-radius: 20px;
}
.sesb-badge--split {
  background: rgba(0, 173, 208, 0.12);
  color: #006174;
}
.sesb-badge--active {
  background: rgba(105, 190, 40, 0.12);
  color: #3f7218;
}
.sesb-badge--expired {
  background: rgba(245, 67, 89, 0.12);
  color: #ee0d29;
}

.sesb-selbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  background: rgba(0, 173, 208, 0.06);
  border: 1px solid rgba(0, 173, 208, 0.28);
  border-radius: 8px;
  padding: 8px 12px;
}
.sesb-selbar__n {
  font-size: 13px;
  font-weight: 600;
  color: #006174;
  margin-right: 4px;
}

.sesb-selbar--groups {
  border-left-width: 3px;
}

.sesb-movebox {
  width: 200px;
}
.sesb-movebox .fsc__control {
  height: 34px;
  padding-top: 0;
  padding-bottom: 0;
}

.sesb-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #6d6e71;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
}
.sesb-btn i {
  font-size: 12px;
}
.sesb-btn:hover {
  background: #f1f1f2;
  border-color: #d6dbde;
}
.sesb-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.sesb-btn--primary:hover {
  background: #4cae4c;
  border-color: #4cae4c;
}
.sesb-btn--danger {
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.4);
}
.sesb-btn--danger:hover {
  background: rgba(245, 67, 89, 0.08);
  border-color: rgb(245, 67, 89);
}
.sesb-btn--ghost {
  border-color: transparent;
  background: transparent;
  color: #ccc;
}
.sesb-btn--ghost:hover {
  background: #f1f1f2;
  color: #6d6e71;
}
.sesb-btn:focus-visible {
  outline: 2px solid rgb(105, 190, 40);
  outline-offset: 1px;
}

.sesb-dl {
  position: relative;
}
.sesb-dl__caret {
  margin-left: 2px;
  font-size: 11px;
}
.sesb-dl__backdrop {
  position: fixed;
  inset: 0;
  z-index: 10;
}
.sesb-dl__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 11;
  min-width: 200px;
  padding: 6px;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.sesb-dl__item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #6d6e71;
  font-size: 13px;
  font-weight: 500;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-align: left;
  cursor: pointer;
}
.sesb-dl__item i {
  font-size: 12px;
  color: #ccc;
}
.sesb-dl__item:hover {
  background: #f1f1f2;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/invitations/detail/invitation-detail.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA1YA;EACE,uBAAA;EACA,iBAAA;AA6YF;AA3YE;EAJF;IAI8B,uBAAA;EA+Y5B;AACF;AA/YE;EALF;IAK8B,uBAAA;EAmZ5B;AACF;;AAhZA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,WDsBkB;ECrBlB,eAAA;AAmZF;AAjZE;EACE,aAAA;EACA,mBAAA;AAmZJ;AAlZI;EAA4B,YAAA;EAAc,aAAA;EAAe,WDgBzC;EChBoE,eAAA;AAwZxF;AAvZI;EAAI,cDQa;ECRe,qBAAA;EAAuB,4BAAA;AA4Z3D;AA5ZyF;EAAU,uBDNnF;ACqahB;AA9ZI;EAAe,cDYE;ECZ0B,gBAAA;AAka/C;;AA7ZA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAgaF;AA9ZE;EAPF;IAO8B,sBAAA;IAAwB,uBAAA;EAmapD;AACF;;AAjaA;EAA0B,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,iBAAA;EAAmB,YAAA;AAya5F;;AAxaA;EACE,eAAA;EACA,gBAAA;EACA,cDPmB;ECQnB,SAAA;EACA,uBAAA;EACA,wEDlDW;ECmDX,gBAAA;EAEA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA0aF;AAzaE;EAdF;IAc8B,eAAA;EA6a5B;AACF;;AA5aA;EAAwB,aAAA;EAAe,QAAA;EAAU,cAAA;AAkbjD;;AA/aA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAkbF;AAjbE;EAAI,eAAA;EAAiB,oBAAA;EAAsB,YAAA;AAsb7C;;AApbA;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAubF;;AAnbA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wED/FW;ECgGX,gBAAA;EACA,cD9DmB;EC+DnB,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAsbF;AApbE;EAA0B,aAAA;EAAe,mBAAA;EAAqB,oBAAA;AAybhE;AAxbE;EAAU,mBD7DU;EC6DwB,kBD9D1B;AC0fpB;AA3bE;EAAkB,mCAAA;EAA0C,oCAAA;EAA2C,uBDjFvF;ACihBlB;AA/bE;EACE,6BDpFY;ECoFgB,WAAA;EAAa,+BDpF7B;ACuhBhB;AAlcI;EAAU,mBAAA;EAAwC,qBAAA;AAsctD;AAncE;EACE,4BD3FY;EC2FgB,WAAA;EAAa,8BD3F7B;ACkiBhB;AAtcI;EAAU,mBAAA;EAAwC,qBAAA;AA0ctD;AAxcE;EACE,4BD/FY;EC+FgB,WAAA;EAAa,8BD/F7B;AC2iBhB;AA3cI;EAAU,mBAAA;EAAwC,qBAAA;AA+ctD;AA7cE;EACE,gBAAA;EAAkB,yBAAA;EAA2B,uBDnGjC;ACojBhB;AAhdI;EAAU,mCAAA;EAAwC,yBAAA;EAA2B,uBDpGjE;ACyjBhB;;AAhdA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAmdF;;AAjdA;EAAmB,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,mBAAA;AAwdvF;;AAvdA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cD9FrF;AC6jBrB;;AAzdE;EAAU,eAAA;EAAiB,eAAA;EAAiB,cDzGzB;ECyGqD,iBAAA;EAAmB,gBAAA;AAie7F;AA7dE;EACE,gBAAA;EAAkB,kBAAA;EAClB,eAAA;EAAiB,cD1GA;EC0G4B,gBAAA;EAAkB,gBAAA;EAC/D,mCAAA;EACA,yCAAA;EACA,kBAAA;AAmeJ;AAjeI;EAAS,gBAAA;EAAkB,cAAA;AAqe/B;AAneE;EAAW,eAAA;AAseb;AAreE;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,mBAAA;EAC/D,oBAAA;EAAsB,gCAAA;AA4e1B;AA1eI;EAJF;IAI8B,QAAA;EA8e9B;AACF;AA5eE;EAAU,eAAA;EAAiB,cDzHR;ECyHoC,mBAAA;AAifzD;AAhfE;EAAS,OAAA;AAmfX;;AA7eA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAgfF;;AAzeA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wED5LW;EC6LX,cDrJmB;ECsJnB,mCAAA;EACA,yCAAA;EACA,mBAAA;AA4eF;AA1eE;EAAM,eAAA;EAAiB,cAAA;AA8ezB;AA7eE;EAAS,gBAAA;EAAkB,cAAA;AAif7B;AA/eE;EACE,oCAAA;EACA,qCAAA;AAifJ;AAhfI;EAAM,cAAA;AAmfV;AAlfI;EAAS,cAAA;AAqfb;AAlfE;EAxBF;IAwB8B,mBAAA;EAsf5B;AACF;;AAnfA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AAsfF;AArfE;EAJF;IAI8B,qCAAA;EAyf5B;AACF;;AAxfA;EAAsB,gBAAA;EAAkB,iBAAA;EAAmB,6BAAA;AA8f3D;;AA7fA;EAAc,cAAA;EAAgB,WD7KV;EC6KqC,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,kBAAA;AAugB/I;;AAtgBA;EAAc,eAAA;EAAiB,cDrLV;ACgsBrB;;AAtgBE;EAAM,uBDxMQ;ACktBhB;;AAxgBA;EAAa,cAAA;EAAgB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,kBAAA;EAAoB,cAAA;AAihB5G;;AA5gBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,wED5OW;EC6OX,6BAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gEAAA;AA+gBF;AA7gBE;EAAU,mCAAA;EAAuC,qCAAA;AAihBnD;AAhhBE;EAAkB,oCAAA;EAAmC,mBAAA;AAohBvD;AAlhBE;EACE,kCAAA;EACA,uBDlOc;ACsvBlB;AAnhBI;EAAU,mCAAA;EAA0C,oCAAA;AAuhBxD;AAthBI;EAAkB,+BDpOJ;AC6vBlB;AAthBE;EAAO,gBAAA;AAyhBT;AAxhBE;EAAS,gBAAA;EAAkB,YAAA;AA4hB7B;AA3hBE;EAAU,eAAA;EAAiB,YAAA;EAAc,gBAAA;AAgiB3C;;AA5hBA;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AA+hBF;AA7hBE;EATF;IASyB,mBAAA;EAiiBvB;AACF;AAhiBE;EAAa,eAAA;EAAiB,QAAA;EAAU,+BAAA;EAAiC,UAAA;AAsiB3E;AAriBE;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0EAAA;EACA,gBAAA;AAuiBJ;AAriBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qDAAA;EACA,gCAAA;AAuiBJ;AAriBE;EAAiB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,6BD9QlD;EC8Q8E,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAijBzL;AAhjBE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cD9P3B;EC8PuD,wEDtS/D;ECsSyF,SAAA;EAAW,gBAAA;AAwjBjH;AAvjBE;EAAc,eAAA;EAAiB,cDpQZ;ECoQwC,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AA8jBhG;AA7jBE;EACE,iBAAA;EAAmB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EACnG,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,WDhQ/E;ECiQhB,0BAAA;EAA4B,cAAA;AA0kBhC;AAzkBI;EAAU,mCAAA;EAA0C,uBDpRtC;ECoR+D,oCAAA;AA8kBjF;AA5kBE;EAAU,aAAA;EAAe,gBAAA;AAglB3B;AA/kBE;EAAa,eAAA;EAAiB,gBAAA;EAAkB,cDvQ7B;ECuQyD,gBAAA;AAqlB9E;AAplBE;EAAY,aAAA;EAAe,yBAAA;EAA2B,SAAA;EAAW,kBAAA;EAAoB,6BAAA;AA2lBvF;;AAxlBA;EACE,mBAAA;AA2lBF;AA1lBE;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cD7Q3F;EC6QuH,kBAAA;AAmmB5I;AAlmBE;EACE,WAAA;EAAa,iBAAA;EAAmB,eAAA;EAAiB,yBAAA;EAAiC,kBAAA;EAClF,cDrRiB;ECqRW,gBAAA;EAAkB,aAAA;EAAe,wDAAA;AA2mBjE;AA1mBI;EAAU,8BDpSE;ECoS4B,4CAAA;AA8mB5C;;AAvmBA;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,wQAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;AA0mBF;;AAnmBA;EAAe,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,uBDvTnD;ACi6BlB;;AAzmBA;EAAc,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,WDtShD;ACs5BpB;;AA9mBA;EAAa,uBD1TK;AC46BlB;;AAjnBA;EAAkB,8BAAA;EAA6C,WDzS3C;AC+5BpB;;AAlnBA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,eAAA;AA0nBhG;;AArnBA;EAAoB,iBAAA;AAynBpB;;AAvnBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDtWW;ECuWX,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AA0nBF;AAxnBE;EAAa,6BDrVC;ECqV2B,WAAA;AA4nB3C;AA5nBwD;EAAU,mBAAA;AA+nBlE;AA/nB4G;EAAc,YAAA;EAAc,mBAAA;AAmoBxI;AAloBE;EAAc,4BDxVA;ECwV4B,WAAA;AAsoB5C;AAtoByD;EAAU,mBAAA;AAyoBnE;AAxoBE;EAAW,gBAAA;EAAkB,WDpUX;ECoUsC,yBAAA;AA6oB1D;AA7oBqF;EAAU,cD3U1E;AC29BrB;;AA5oBA;EAA8B,4BD7Vd;AC6+BhB;;AA7oBA;EAAsB,uBAAA;AAipBtB;;AAhpBA;EAA2B,4BDjWX;ACq/BhB;;AAnpBA;EAAa,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,kBAAA;AA0pBjF;AA1pBqG;EAAQ,gBAAA;AA6pB7G;;AA5pBA;EACE,oBAAA;EAAsB,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAAkB,mBD9UzE;ACi/BtB;;AAjqBA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EACzF,wED7XW;EC6Xe,WDnVR;ECmVmC,gBAAA;EAAkB,YAAA;EAAc,eAAA;EACrF,0BAAA;AA6qBF;AA5qBE;EAAQ,8BAAA;AA+qBV;AA9qBE;EAAU,cD7VS;AC8gCrB;AAhrBE;EAAc,gBAAA;EAAkB,uBD5WlB;ACgiChB;;AAlrBA;EAAc,iBAAA;EAAmB,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;AAyrBpE;;AAxrBA;EACE,iBAAA;EAAmB,yBAAA;EAAiC,kBAAA;EAAoB,mBD1VpD;EC0VsF,gBAAA;AA+rB5G;AA9rBE;EAAa,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,cD9VjD;EC8V6E,gCAAA;EAAwC,gBAAA;AAssB1I;AArsBE;EACE,SAAA;EAAW,kBAAA;EAAoB,wEDxYtB;ECwYgD,eAAA;EAAiB,iBAAA;EAC1E,cDtWiB;ECsWW,qBAAA;EAAuB,sBAAA;EAAwB,gBAAA;EAAkB,YAAA;AA+sBjG;;AA5sBA;EAAiB,yCAAA;AAgtBjB;;AA/sBA;EAAe,eAAA;EAAiB,eAAA;EAAiB,uBDrX/B;AC0kClB;;AAptBA;EACE,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AA0tBzE;;AAxtBA;EACE,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,kBAAA;EAAoB,eAAA;EAAiB,cD/WtF;AC+kCrB;AA/tBE;EAAQ,6BAAA;AAkuBV;AAjuBE;EAAS,gBAAA;EAAkB,cD5WR;ACilCrB;;AAnuBA;EACE,aAAA;EAAe,uBAAA;EAAyB,QAAA;EAAU,kBAAA;EAAoB,kBAAA;EAAoB,iBAAA;EAAmB,iBAAA;EAC7G,mCAAA;EAAuC,cAAA;EAAmC,yCAAA;AA8uB5E;AA7uBE;EAAM,eAAA;AAgvBR;;AA5uBA;EAAa,aAAA;EAAe,SAAA;EAAW,mBAAA;EAAqB,eAAA;AAmvB5D;;AAlvBA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,WDpXjC;ECoX4D,eAAA;EAAiB,mBAAA;EAAqB,4BAAA;AA2vBtH;;AA1vBA;EAAwB,cD5XH;AC0nCrB;;AA7vBA;EAAwB,uBD3YR;EC2Y+B,yCAAA;AAkwB/C;;AA/vBA;EAAc,eAAA;EAAiB,SAAA;AAowB/B;;AAnwBA;EAAe,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;AA0wB7D;;AAvwBA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,SAAA;EAC9C,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAC9D,cDlYmB;ECkYS,wED1ajB;AC2rCb;;AA/wBA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,YAAA;EAAc,cAAA;EACnG,oBAAA;EAAsB,mBDnYF;ECmYoC,WDpYtC;ECoYiE,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;AA4xBxH;;AAxxBA;EACE,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAChG,WD1YkB;EC0YS,eAAA;EAAiB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAChH,0BAAA;AAqyBF;AApyBE;EAAU,mBD3YU;EC2YwB,kBD5Y1B;EC4Y4D,cDnZ3D;AC4rCrB;AAxyBE;EAAkB,yCAAA;AA2yBpB;;AAzyBA;EAAuB;IAAK,yBAAA;EA8yB1B;AACF;AA5yBA;EAAe,aAAA;AA+yBf;;AA5yBA;EACE,kBAAA;EACA,oBAAA;AA+yBF;AA7yBE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,gCAAA;AAkzBhD;AAjzBE;EAAqB,yBAAA;AAozBvB;AAlzBE;EAAc,eAAA;EAAiB,QAAA;EAAU,WAAA;AAuzB3C;AAtzBE;EACE,kBAAA;EAAoB,qBAAA;EAAuB,OAAA;EAAS,WAAA;EAAa,gBAAA;EACjE,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EACnD,0EAAA;EACA,YAAA;EAAc,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAi0BzD;AAh0BI;EAAW,UAAA;EAAY,QAAA;AAo0B3B;AAl0BE;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,WAAA;EAAa,iBAAA;EAC5D,YAAA;EAAc,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;EACpD,eAAA;EAAiB,gBAAA;EAAkB,wEDjd1B;ECidoD,cD9a5C;EC+ajB,gBAAA;EAAkB,0BAAA;AA+0BtB;AA90BI;EAAI,WAAA;EAAa,eAAA;EAAiB,uBD9btB;ACixChB;AAl1BI;EAAU,mCAAA;EAAwC,cD5ajC;ACkwCrB;;AAn1BA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAs1BF;AAr1BE;EAAI,kBAAA;EAAoB,UAAA;EAAY,WDjblB;ECib6C,eAAA;EAAiB,oBAAA;AA41BlF;AA31BE;EACE,YAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wEDneS;ECoeT,cDjciB;ECkcjB,aAAA;EACA,gBAAA;EACA,wDAAA;AA61BJ;AA51BI;EAAU,8BDndE;ECmd4B,4CAAA;AAg2B5C;;AA31BA;EAAY,kBAAA;AA+1BZ;;AA91BA;EAAc,WDpcM;ACsyCpB;;AAj2BA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cD5cmB;EC6cnB,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AAo2BF;AAn2BE;EAAU,cDxdS;AC8zCrB;;AAl2BA;EAAiB,oBAAA;EAAsB,QAAA;EAAU,mBAAA;AAw2BjD;;AAp2BA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAu2BF;AAr2BE;EAAU,4BD5fI;EC4fwB,WAAA;EAAa,8BD5frC;EC4fmE,sBAAA;AA22BnF;AAz2BE;EACE,eAAA;AA22BJ;AA12BI;EACE,4BD9fY;EC8fkB,WAAA;EAAa,8BD9f/B;EC+fZ,4CAAA;AA82BN;AA12BI;EAAU,mBAAA;EAAqB,WAAA;EAAa,qBAAA;AA+2BhD;;AA12BA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,YAAA;EAAc,eAAA;EACnE,mCAAA;EAAkC,kBAAA;EAAoB,6BD3gBxC;EC2gBoE,WAAA;EAClF,eAAA;EAAiB,gBAAA;EAAkB,wEDniBxB;ECmiBkD,eAAA;EAAiB,mBAAA;EAC9E,0BAAA;AAw3BF;AAv3BE;EAAI,eAAA;AA03BN;AAz3BE;EAAU,mBAAA;EAAwC,qBAAA;AA63BpD;;AAz3BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AA43BF;AA33BE;EAAU,eAAA;EAAiB,WDzgBT;ACw4CpB;AA93BE;EAAW,aAAA;EAAe,QAAA;AAk4B5B;AAj4BE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cDzhBiB;EC0hBjB,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAm4BJ;AAl4BI;EAAyC,mBDthBvB;ECshByD,kBDvhB3D;AC65CpB;AAr4BI;EAAc,mBD1hBG;EC0hB8B,WAAA;EAAa,qBD1hB3C;ACo6CrB;AAz4BI;EAAa,YAAA;EAAc,mBAAA;AA64B/B;;AA14BA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AAi5BpE;;AAh5BA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,SAAA;EAAW,eAAA;EAAiB,WD9hB/D;ACs7CpB;AAv5BE;EAAS,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,cDtiB9E;ECsiB0G,eAAA;EAAiB,aAAA;AAg6BhJ;;AA55BA;EAAc,WAAA;EAAa,kBAAA;AAi6B3B;;AAh6BA;EAAoB,eAAA;EAAiB,SAAA;AAq6BrC;;AAp6BA;EAAoC,8CAAA;AAw6BpC;;AAv6BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;AA06BF;AAz6BE;EAAW,gBAAA;EAAkB,uBDtkBf;ACm/ChB;AA56BE;EAAU,gBAAA;EAAkB,WDljBV;ACk+CpB;AA96BE;EAAQ,iBAAA;AAi7BV;AAh7BE;EAAY,iBAAA;EAAmB,eAAA;AAo7BjC;AAj7BE;EACE,mBDxjBkB;ECyjBlB,qBDnjBW;ACs+Cf;;AA/6BA;EAAmB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,cD5jBhD;EC4jB+E,kBAAA;AAu7BvG;AAv7B2H;EAAI,eAAA;AA07B/H;;AAv7BA;EACE,WAAA;EACA,yBAAA;AA07BF;AAx7BE;EAAW,mBDpkBS;AC+/CtB;AA17BE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD9kBiB;EC+kBjB,gCAAA;EACA,gBAAA;EACA,mBAAA;AA47BJ;AA17BE;EACE,gCAAA;EACA,uCAAA;AA47BJ;AA37BI;EAAU,mCAAA;AA87Bd;AA77BI;EAAe,mBAAA;AAg8BnB;AA97BE;EAAW,kBAAA;EAAoB,eAAA;EAAiB,cD9lB7B;EC8lByD,sBAAA;AAo8B9E;;AAl8BA;EAAc,kBAAA;EAAoB,WDzlBd;ECylByC,aAAA;EAAe,eAAA;AAy8B5E;;AAp8BA;EAAiB,cDhmBI;ECgmBwB,eAAA;AAy8B7C;;AAh8BA;EACE,eAAA;EACA,cDvmBsB;ECwmBtB,kBAAA;EACA,kCAAA;EACA,mBAAA;AAm8BF;;AAj8BA;EACE,eAAA;EACA,cD9mBsB;EC+mBtB,kBAAA;EACA,mBAAA;AAo8BF;;AAh8BA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,QAAA;EAAU,gBAAA;AAw8BnF;;AAr8BA;EAAyB,UAAA;EAAY,mBAAA;EAAqB,eAAA;EAAiB,mBDlnB5D;AC8jDf;;AA38BA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,iBAAA;EACrD,yBAAA;EAAiC,oBAAA;EAAsB,gBAAA;EACvD,eAAA;EAAiB,gBAAA;EAAkB,wEDvqBxB;ECuqBkD,cDpoB1C;ECqoBnB,eAAA;EAAiB,0BAAA;AAu9BnB;AAt9BE;EAAI,eAAA;EAAiB,WD/nBH;ACylDpB;AAz9BE;EAAU,kBDhoBQ;ECgoB0B,mBD/nBxB;AC4lDtB;;AA39BA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,iBAAA;EACrD,yBAAA;EAAiC,oBAAA;EAAsB,gBAAA;EACvD,eAAA;EAAiB,gBAAA;EAAkB,wED/qBxB;EC+qBkD,WDroB3C;ECsoBlB,eAAA;EAAiB,0BAAA;AAu+BnB;AAt+BE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,YAAA;EAAc,cAAA;EACnG,oBAAA;EAAsB,mBDxoBJ;ECwoBsC,WDzoBxC;ECyoBmE,eAAA;EAAiB,gBAAA;AAi/BxG;AA/+BE;EAAU,kBD3oBQ;EC2oB0B,cDlpBzB;ACqoDrB;AAl/BE;EAAc,mBD9oBK;EC8oB4B,qBD9oB5B;EC8oB+D,WAAA;AAu/BpF;AAv/BiG;EAAgB,qCAAA;EAA8B,WAAA;AA2/B/I;;AAt/BA;EAAgB,WAAA;EAAa,mBD1oBd;EC0oByC,mBAAA;AA4/BxD;;AAz/BA;EAAmB,cAAA;EAAgB,mBAAA;AA8/BnC;;AA7/BA;EAAa,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,mBAAA;AAogCvD;;AAlgCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBD1pBoB;EC2pBpB,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,cDvqBmB;AC4qDrB;AAngCE;EAAc,WAAA;EAAa,YAAA;EAAc,cAAA;AAwgC3C;AAvgCE;EAAU,gBAAA;EAAkB,mBAAA;AA2gC9B;AA1gCE;EACE,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAC9D,cAAA;EAAgB,mBAAA;EAAqB,oBAAA;EAAsB,gBAAA;EAAkB,mBAAA;AAmhCjF;AAjhCE;EACE,YAAA;EAAc,gBAAA;EAAkB,WDzqBhB;ECyqB2C,eAAA;EAC3D,eAAA;EAAiB,cAAA;EAAgB,UAAA;EAAY,oBAAA;EAAsB,mBAAA;EACnE,4BAAA;AA0hCJ;AAzhCI;EAAU,uBDjsBE;AC6tDhB;AA1hCE;EACE,YAAA;EACA,gBAAA;EACA,WDjrBgB;ECkrBhB,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,4BAAA;AA4hCJ;AA3hCI;EAAU,uBD3sBI;ACyuDlB;AA1hCE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;AA4hCJ;;AAxhCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,yCAAA;EACA,uBD/tBc;ECguBd,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDzvBW;EC0vBX,eAAA;EACA,0BAAA;AA2hCF;AA1hCE;EAAU,mCAAA;EAAwC,mBAAA;AA8hCpD;;AA3hCA;EAAa,uBD1uBG;EC0uBoB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;AAqiCnI;AAriC6I;EAAU,0BAAA;AAwiCvJ;;AAviCA;EAAqB,uBDxuBH;ACmxDlB;;AAziCA;EAAiB,eAAA;EAAiB,eAAA;EAAiB,cAAA;EAAgB,8BAAA;EAAgC,iBAAA;AAijCnG;;AA9iCA;EAAY,oBAAA;EAAsB,mBAAA;EAAqB,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AAwjClI;;AAvjCA;EAAkB,oCAAA;EAAwC,cAAA;AA4jC1D;;AA3jCA;EAAoB,mBAAA;EAAqB,cAAA;AAgkCzC;;AA9jCA;EAAc,oBAAA;EAAsB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,mBAAA;EAAqB,WAAA;EAAa,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;EAAgB,cAAA;AA2kCnL;;AAxkCA;EAA+B,mBD3tBhB;EC2tB2C,cDpuBrC;ACizDrB;;AA5kCA;EAAuC,mBDluBjB;ECkuBmD,cDruBpD;ACszDrB;;AA9kCA;EACE,eAAA;EAAiB,QAAA;EAAU,eAAA;EAAiB,aAAA;EAAe,uBAAA;EAAyB,uBAAA;EAAyB,kBAAA;AAulC/G;AAtlCE;EAFF;IAEyB,mBAAA;EA0lCvB;AACF;AAzlCE;EAAa,eAAA;EAAiB,QAAA;EAAU,+BAAA;EAAiC,UAAA;AA+lC3E;AA9lCE;EACE,kBAAA;EAAoB,UAAA;EAAY,uBAAA;EAAyB,+BAAA;EACzD,aAAA;EAAe,sBAAA;EAAwB,gBAAA;EAAkB,mBAAA;EACzD,0EAAA;EAA4E,gBAAA;AAumChF;AArmCE;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAC/C,qDAAA;EACA,gCAAA;AA0mCJ;AAxmCE;EAAiB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,6BDxwBlD;ECwwB8E,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAonCzL;AAnnCE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDxvB3B;ECwvBuD,wEDhyB/D;ECgyByF,SAAA;EAAW,gBAAA;AA2nCjH;AA1nCE;EAAc,eAAA;EAAiB,cD9vBZ;EC8vBwC,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AAioChG;AAhoCE;EACE,iBAAA;EAAmB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EACnG,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,WD1vB/E;EC2vBhB,0BAAA;EAA4B,cAAA;AA6oChC;AA5oCI;EAAU,mCAAA;EAA0C,uBD9wBtC;EC8wB+D,oCAAA;AAipCjF;AA/oCE;EACE,aAAA;EAAe,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,cDtwBnD;AC25DrB;AAppCI;EAAI,gBAAA;AAupCR;AArpCE;EAAW,WDlwBO;AC05DpB;AAvpCE;EAAW,gBAAA;EAAkB,cDrwBV;ECqwBsC,6BAAA;AA4pC3D;AA3pCE;EAAS,wBAAA;AA8pCX;AA7pCE;EACE,gBAAA;EAAkB,kBAAA;AAgqCtB;AA/pCI;EAAK,kBAAA;AAkqCT;AAjqCI;EAAI,cD1wBa;EC0wBe,0BAAA;AAqqCpC;AApqCI;EAAU,uBD9xBE;ACq8DhB;AArqCE;EAAU,2BAAA;AAwqCZ;AAvqCE;EAAY,aAAA;EAAe,yBAAA;EAA2B,SAAA;EAAW,kBAAA;EAAoB,6BAAA;AA8qCvF;;AA1qCA;EACE,eAAA;EAAiB,QAAA;EAAU,eAAA;EAAiB,aAAA;EAAe,uBAAA;EAAyB,uBAAA;EAAyB,kBAAA;AAmrC/G;AAlrCE;EAFF;IAEyB,mBAAA;EAsrCvB;AACF;AArrCE;EAAa,eAAA;EAAiB,QAAA;EAAU,+BAAA;EAAiC,UAAA;AA2rC3E;AA1rCE;EACE,kBAAA;EAAoB,UAAA;EAAY,uBAAA;EAAyB,+BAAA;EACzD,aAAA;EAAe,sBAAA;EAAwB,gBAAA;EAAkB,mBAAA;EACzD,0EAAA;EAA4E,gBAAA;AAmsChF;AAjsCE;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAC/C,qDAAA;EACA,gCAAA;AAssCJ;AApsCE;EAAiB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,6BDlzBlD;ECkzB8E,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAgtCzL;AA/sCE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDlyB3B;ECkyBuD,wED10B/D;EC00ByF,SAAA;EAAW,gBAAA;AAutCjH;AAttCE;EAAc,eAAA;EAAiB,cDxyBZ;ECwyBwC,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AA6tChG;AA5tCE;EACE,iBAAA;EAAmB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EACnG,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,WDpyB/E;ECqyBhB,0BAAA;EAA4B,cAAA;AAyuChC;AAxuCI;EAAU,mCAAA;EAA0C,uBDxzBtC;ECwzB+D,oCAAA;AA6uCjF;AA3uCE;EAAU,aAAA;EAAe,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,cD/yB3D;ACiiErB;AAjvCE;EAAY,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cD3yB/F;EC2yB2H,kBAAA;AA0vChJ;AAzvCE;EACE,WAAA;EAAa,iBAAA;EAAmB,eAAA;EAAiB,yBAAA;EAAiC,kBAAA;EAClF,cDnzBiB;ECmzBW,gBAAA;EAAkB,aAAA;EAAe,mBAAA;AAkwCjE;AAjwCI;EAAU,8BDl0BE;ECk0B4B,4CAAA;AAqwC5C;AAnwCE;EAAU,gBAAA;EAAkB,WD/yBV;EC+yBqC,eAAA;AAwwCzD;AAvwCE;EAAU,uBDr0BI;ECq0BmB,eAAA;EAAiB,0BAAA;AA4wCpD;AA3wCE;EACE,gBAAA;EAAkB,kBAAA;EAAoB,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,cDzzB5E;EC0zBjB,mCAAA;EAAwC,yCAAA;AAmxC5C;AAjxCE;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,cAAA;EAAoC,kBAAA;AAwxCxG;AAvxCI;EAAM,eAAA;AA0xCV;AAxxCE;EACE,SAAA;EAAW,kBAAA;AA2xCf;AA1xCI;EAAK,kBAAA;AA6xCT;AA7xC6B;EAAe,gBAAA;AAgyC5C;AA9xCE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,kBAAA;EACvE,gBAAA;EAAkB,yCAAA;EAA8C,gBAAA;EAAkB,cDj0BjE;ECi0B6F,mBAAA;AAwyClH;AAtyCE;EACE,uBDv1BY;ECu1BW,eAAA;EAAiB,eAAA;EAAiB,cAAA;AA2yC7D;AA1yCI;EAAU,cAAA;AA6yCd;AA3yCE;EAAa,eAAA;EAAiB,gBAAA;EAAkB,cDv0B7B;ECu0ByD,kBAAA;AAizC9E;AAhzCE;EAAa,eAAA;EAAiB,WDt0BZ;ECs0BuC,eAAA;AAqzC3D;AApzCE;EACE,aAAA;EAAe,uBAAA;EAAyB,QAAA;EAAU,kBAAA;EAAoB,eAAA;EAAiB,cD/0BtE;EC+0BkG,eAAA;AA4zCvH;AA3zCI;EAAQ,eAAA;EAAiB,cAAA;AA+zC7B;AA7zCE;EAAY,aAAA;EAAe,yBAAA;EAA2B,SAAA;EAAW,kBAAA;EAAoB,6BAAA;EAAqC,mBAAA;AAq0C5H;;AAj0CA;EACE,eAAA;EAAiB,QAAA;EAAU,eAAA;EAAiB,aAAA;EAAe,uBAAA;EAAyB,uBAAA;EAAyB,kBAAA;AA00C/G;AAz0CE;EAFF;IAEyB,mBAAA;EA60CvB;AACF;AA50CE;EAAa,eAAA;EAAiB,QAAA;EAAU,+BAAA;EAAiC,UAAA;AAk1C3E;AAj1CE;EACE,kBAAA;EAAoB,UAAA;EAAY,uBAAA;EAAyB,8BAAA;EACzD,aAAA;EAAe,sBAAA;EAAwB,gBAAA;EAAkB,mBAAA;EACzD,0EAAA;EAA4E,gBAAA;AA01ChF;AAx1CE;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAC/C,qDAAA;EACA,gCAAA;AA61CJ;AA31CE;EAAiB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,6BDj3BlD;ECi3B8E,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAu2CzL;AAt2CE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDj2B3B;ECi2BuD,wEDz4B/D;ECy4ByF,SAAA;EAAW,gBAAA;AA82CjH;AA72CE;EAAc,eAAA;EAAiB,cDv2BZ;ECu2BwC,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AAo3ChG;AAn3CE;EACE,iBAAA;EAAmB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EACnG,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,WDn2B/E;ECo2BhB,0BAAA;EAA4B,cAAA;AAg4ChC;AA/3CI;EAAU,mCAAA;EAA0C,uBDv3BtC;ECu3B+D,oCAAA;AAo4CjF;AAl4CE;EAAU,aAAA;EAAe,gBAAA;AAs4C3B;AAr4CE;EAAY,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,kBAAA;EAAoB,6BAAA;AA44C5F;AA14CE;EACE,WAAA;EAAa,iBAAA;EAAmB,eAAA;EAAiB,yBAAA;EAAiC,kBAAA;EAClF,cDn3BiB;ECm3BW,gBAAA;EAAkB,aAAA;EAAe,wEDt5BpD;ECu5BT,wDAAA;AAm5CJ;AAl5CI;EAAU,8BDn4BE;ECm4B4B,4CAAA;AAs5C5C;;AAj5CA;EAAe,aAAA;EAAe,gBAAA;EAAkB,UAAA;EAAY,gBAAA;AAw5C5D;;AAv5CA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,OAAA;EAAS,YAAA;EACvD,WDt3BkB;ECs3BS,eAAA;EAAiB,gBAAA;AAg6C9C;AA95CE;EAAe,cAAA;AAi6CjB;AA/5CE;EAAW,WAAA;EAAa,OAAA;EAAS,WAAA;EAAa,eAAA;EAAiB,cAAA;EAAgB,mBAAA;EAAqB,kBAAA;AAw6CtG;AAv6CE;EAAsB,aAAA;AA06CxB;AAz6CE;EAAmB,6BD/4BL;AC2zEhB;AA16CE;EACE,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,mBAAA;EAAqB,WD/3BpD;ECg4BhB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,iCAAA;AAs7C3H;AAp7CE;EAAW,mBAAA;AAu7Cb;AAt7CE;EAAc,cAAA;AAy7ChB;AAx7CE;EAAqB,mBAAA;EAAqB,WAAA;AA47C5C;AA37CE;EAAmB,6BDx5BL;ECw5BiC,WAAA;AA+7CjD;;AA37CA;EAAsB,mBAAA;AA+7CtB;;AA97CA;EAAe,eAAA;EAAiB,WD14BZ;EC04BuC,gBAAA;AAo8C3D;;AAn8CA;EAAkB,gBAAA;EAAkB,iBAAA;EAAmB,wEDr7B1C;ECq7BoE,eAAA;AA08CjF;;AAz8CA;EAAa,kBAAA;AA68Cb;;AA58CA;EAAc,eAAA;EAAiB,WD74BX;EC64BsC,gBAAA;AAk9C1D;;AAj9CA;EAAc,eAAA;EAAiB,cDr5BV;ECq5BsC,eAAA;AAu9C3D;;AAt9CA;EAAY,eAAA;EAAiB,gBAAA;EAAkB,WD/4B3B;EC+4BsD,kBAAA;EAAoB,kBAAA;AA89C9F;;AA79CA;EAAe,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;EAAiB,cDv5BjD;AC23ErB;AAp+CkG;EAAK,kBAAA;AAu+CvG;;AAt+CA;EACE,aAAA;EAAe,uBAAA;EAAyB,QAAA;AA2+C1C;AA1+CE;EAAgB,OAAA;AA6+ClB;;AA3+CA;EACE,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAChG,uBD56Bc;EC46BS,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EACrG,0BAAA;AAw/CF;AAv/CE;EAAU,mCAAA;EAAwC,oCAAA;AA2/CpD;;AAn/CA;EACE,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,qBAAA;EAC9D,gBAAA;EAAkB,mBAAA;AA0/CpB;AAx/CE;EAAW,mCAAA;EAAwC,cAAA;AA4/CrD;AA3/CE;EAAY,oCAAA;EAAwC,cAAA;AA+/CtD;AA9/CE;EAAa,mCAAA;EAA0C,cAAA;AAkgDzD;;AA9/CA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,mBAAA;EAC/D,mCAAA;EAAwC,yCAAA;EACxC,kBAAA;EAAoB,iBAAA;AAugDtB;AAtgDE;EAAO,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAoC,iBAAA;AA4gDhF;;AAvgDA;EAAuB,sBAAA;AA2gDvB;;AA1gDA;EACE,YAAA;AA6gDF;AA5gDE;EAAgB,YAAA;EAAc,cAAA;EAAgB,iBAAA;AAihDhD;;AA9gDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cDr8BmB;ECs8BnB,eAAA;EACA,gBAAA;EACA,wEDh/BW;ECi/BX,cAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;AAihDF;AA/gDE;EAAI,eAAA;AAkhDN;AAjhDE;EAAU,mBD58BU;EC48BwB,qBAAA;AAqhD9C;AAnhDE;EACE,6BDn+BY;ECm+BgB,WAAA;EAAa,+BDn+B7B;AC0/EhB;AAthDI;EAAU,mBD98BK;EC88B0B,qBD98B1B;ACw+EnB;AAvhDE;EACE,uBDv+Bc;ECu+BW,oCAAA;AA0hD7B;AAzhDI;EAAU,mCAAA;EAA0C,8BDx+BtC;ACqgFlB;AA1hDE;EACE,yBAAA;EAA2B,uBAAA;EAAyB,WD19BpC;ACw/EpB;AA7hDI;EAAU,mBD19BQ;EC09B0B,cD79B3B;AC8/ErB;AA9hDE;EAAkB,oCAAA;EAAmC,mBAAA;AAkiDvD;;AA/hDA;EACE,kBAAA;AAkiDF;AAhiDE;EAAW,gBAAA;EAAkB,eAAA;AAoiD/B;AAniDE;EAAc,eAAA;EAAiB,QAAA;EAAU,WAAA;AAwiD3C;AAviDE;EACE,kBAAA;EAAoB,qBAAA;EAAuB,OAAA;EAAS,WAAA;EACpD,gBAAA;EAAkB,YAAA;EAClB,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EACnD,0CAAA;AA+iDJ;AA7iDE;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,WAAA;EAC9C,iBAAA;EAAmB,YAAA;EAAc,kBAAA;EAAoB,uBAAA;EACrD,cDj/BiB;ECi/BW,eAAA;EAAiB,gBAAA;EAAkB,wEDzhCtD;EC0hCT,gBAAA;EAAkB,eAAA;AAyjDtB;AAxjDI;EAAI,eAAA;EAAiB,WDj/BL;AC6iFpB;AA3jDI;EAAU,mBDj/BQ;AC+iFtB","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n\n// ─────────────────────────────────────────────\n// Single invitation view — matches the Rosters/listing chrome\n// ─────────────────────────────────────────────\n.invd {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// Breadcrumb\n.invd-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n  flex-wrap: wrap;\n\n  li {\n    display: flex;\n    align-items: center;\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; font-size: 11px; }\n    a { color: $body-content-color; text-decoration: none; transition: color 0.15s ease; &:hover { color: $clarify-color; } }\n    &.is-current { color: $color-neutral-dark; font-weight: 600; }\n  }\n}\n\n// Header\n.invd-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n\n  @media (max-width: 640px) { flex-direction: column; align-items: flex-start; }\n}\n// Title + status stay on one line; the name truncates with an ellipsis when long.\n.invd-header__title-row { display: flex; align-items: center; gap: 12px; flex-wrap: nowrap; min-width: 0; }\n.invd-title {\n  font-size: 26px;\n  font-weight: 700;\n  color: $color-neutral-dark;\n  margin: 0;\n  letter-spacing: -0.02em;\n  font-family: $font-stack;\n  line-height: 1.2;\n  // Cap the name length and ellipsize; min-width:0 lets it shrink instead of pushing the pill.\n  min-width: 0;\n  max-width: 42ch;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  @media (max-width: 640px) { font-size: 21px; }\n}\n.invd-header__actions { display: flex; gap: 8px; flex-shrink: 0; }\n\n// Status pill (editable select inside a coloured pill)\n.invd-status-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  flex-shrink: 0;\n  i { font-size: 10px; pointer-events: none; opacity: 0.8; }\n}\n.invd-status {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n  outline: none;\n}\n\n// Buttons\n.invd-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  background: #fff;\n  color: $body-content-color;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  white-space: nowrap;\n\n  &[disabled], &:disabled { opacity: 0.45; cursor: not-allowed; pointer-events: none; }\n  &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n  &--danger:hover { background: rgba($implement-color, 0.06); border-color: rgba($implement-color, 0.3); color: $implement-color; }\n  &--primary {\n    background: $develop-color; color: #fff; border-color: $develop-color;\n    &:hover { background: darken($develop-color, 8%); border-color: darken($develop-color, 8%); }\n  }\n  // Same Clarify blue as --unlock, so the two action buttons match.\n  &--blue {\n    background: $clarify-color; color: #fff; border-color: $clarify-color;\n    &:hover { background: darken($clarify-color, 8%); border-color: darken($clarify-color, 8%); }\n  }\n  &--unlock {\n    background: $clarify-color; color: #fff; border-color: $clarify-color;\n    &:hover { background: darken($clarify-color, 8%); border-color: darken($clarify-color, 8%); }\n  }\n  &--ghost {\n    background: none; border-color: transparent; color: $clarify-color;\n    &:hover { background: rgba($clarify-color, 0.06); border-color: transparent; color: $clarify-color; }\n  }\n}\n\n// Cards\n.invd-card {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n.invd-card__head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; }\n.invd-card__title { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: $color-neutral-dark; }\n\n// Activity Groups — the CTA/guidance state, and the inline board's own layout. The board's\n// toolbar buttons/badges reuse the `.sesb-*` classes from session-board-page.component.scss —\n// duplicated below since that page isn't mounted here (see the block further down).\n.invd-activity {\n  &__lead { margin: 0 0 8px; font-size: 13px; color: $body-content-color; line-height: 1.55; max-width: 620px; }\n  // Informational note. Was $color-neutral-mid (#ccc) on $color-neutral-light (#f1f1f2) — about\n  // 1.6:1, unreadable. Reads as information, so it takes the Clarify tint rather than the amber\n  // .inv-key-notice warning treatment, and matches that block's shape (6px radius, 1px border).\n  &__note {\n    margin: 0 0 18px; padding: 10px 14px;\n    font-size: 12px; color: $color-neutral-dark; line-height: 1.6; max-width: 620px;\n    background: rgba($clarify-color, 0.06);\n    border: 1px solid rgba($clarify-color, 0.22);\n    border-radius: 6px;\n\n    strong { font-weight: 700; color: darken($clarify-color, 18%); }\n  }\n  &__board { margin-top: 4px; }\n  &__toolbar {\n    display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 16px;\n    padding-bottom: 14px; border-bottom: 1px solid $color-grey-1;\n\n    @media (max-width: 640px) { gap: 6px; }\n  }\n  // Same #ccc-on-white contrast problem as the note above.\n  &__meta { font-size: 12px; color: $color-neutral-dark; white-space: nowrap; }\n  &__gap { flex: 1; }\n}\n\n// Status + action row. The pill and the button are adjacent targets, so they need a real gap\n// (8px is the documented minimum; 12px here) and they wrap together on a narrow card rather\n// than colliding.\n.invd-activity__cta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n// Eligibility status: figure first, then what it counts. One type size throughout — weight, not\n// size, carries the emphasis — and the same 13px/8px-vertical rhythm as .invd-btn beside it, so\n// the two sit at equal height. Amber while some participants can't be grouped, green once all\n// can: the state is legible from icon and tint before a word is read.\n.invd-elig {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.5;\n  font-family: $font-stack;\n  color: $color-neutral-dark;\n  background: rgba($ideate-color, 0.08);\n  border: 1px solid rgba($ideate-color, 0.25);\n  white-space: nowrap;\n\n  .fa { font-size: 13px; color: darken($ideate-color, 12%); }\n  strong { font-weight: 700; color: darken($ideate-color, 18%); }\n\n  &.is-ready {\n    background: rgba($develop-color, 0.09);\n    border-color: rgba($develop-color, 0.3);\n    .fa { color: darken($develop-color, 12%); }\n    strong { color: darken($develop-color, 18%); }\n  }\n\n  @media (max-width: 480px) { white-space: normal; }\n}\n\n// Summary grid\n.invd-summary {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px 20px;\n  @media (max-width: 767px) { grid-template-columns: repeat(2, 1fr); }\n}\n.invd-summary--more { margin-top: 16px; padding-top: 16px; border-top: 1px solid $color-grey-1; }\n.invd-kv__k { display: block; color: $color-neutral-mid; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 3px; }\n.invd-kv__v { font-size: 13px; color: $body-content-color; }\n\n// Assessment link — a plain toolbar button that copies the URL. The URL field and the\n// \"Open\" action it replaced lived in the summary tile, which no longer exists.\n.invd-alink-btn {\n  .fa { color: $clarify-color; }\n}\n.invd-soon { font-size: 9px; background: #f1f1f2; border-radius: 8px; padding: 1px 5px; font-style: normal; color: #8a9099; }\n\n// Scoring keys — compact chip in the stage-filter row, after \"Invite more\".\n// The whole chip is the button (opens the keys modal); the trailing \"+\" is its\n// affordance. Tinted red while keys are short, green once enough are assigned.\n.invd-keychip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 10px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: $font-stack;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: rgba($develop-color, 0.12);\n  color: darken($develop-color, 12%);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n\n  &:hover { background: rgba($develop-color, 0.2); border-color: rgba($develop-color, 0.5); }\n  &:focus-visible { outline: 2px solid $develop-color; outline-offset: 1px; }\n\n  &--warn {\n    background: rgba($implement-color, 0.1);\n    color: $implement-color;\n    &:hover { background: rgba($implement-color, 0.18); border-color: rgba($implement-color, 0.5); }\n    &:focus-visible { outline-color: $implement-color; }\n  }\n\n  &__n { font-weight: 700; }\n  &__msg { font-weight: 500; opacity: 0.9; }\n  &__plus { font-size: 10px; opacity: 0.7; margin-left: 1px; }\n}\n\n// ── Add scoring keys modal (matches the nt-modal popup chrome) ──\n.invkm {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 50px 20px;\n\n  @media #{$mobile-up} { padding-left: 240px; }\n\n  &__overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); z-index: 0; }\n  &__card {\n    position: relative;\n    z-index: 1;\n    width: min(500px, 100%);\n    max-height: calc(100vh - 100px);\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n  }\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 20px;\n    background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n    border-bottom: 1px solid $color-grey-1;\n  }\n  &__header-icon { width: 36px; height: 36px; border-radius: 8px; background: $develop-color; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }\n  &__title { font-size: 15px; font-weight: 700; color: $color-neutral-dark; font-family: $font-stack; margin: 0; line-height: 1.3; }\n  &__subtitle { font-size: 12px; color: $body-content-color; margin: 2px 0 0; line-height: 1.3; opacity: 0.7; }\n  &__close {\n    margin-left: auto; width: 30px; height: 30px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff;\n    cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; color: $color-neutral-mid;\n    transition: all 0.15s ease; flex-shrink: 0;\n    &:hover { background: rgba($implement-color, 0.06); color: $implement-color; border-color: rgba($implement-color, 0.2); }\n  }\n  &__body { padding: 20px; overflow-y: auto; }\n  &__section { font-size: 13px; font-weight: 700; color: $color-neutral-dark; margin: 0 0 14px; }\n  &__footer { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 20px; border-top: 1px solid $color-grey-1; }\n}\n\n.invkm-field {\n  margin-bottom: 16px;\n  label { display: block; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: $color-neutral-dark; margin-bottom: 6px; }\n  .form-control {\n    width: 100%; padding: 9px 12px; font-size: 13px; border: 1px solid $color-grey-1; border-radius: 6px;\n    color: $body-content-color; background: #fff; outline: none; transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); }\n  }\n}\n// Native selects render as an OS widget that ignores the box styling above, so the modal's\n// dropdowns sat square and short next to the text inputs. Same opt-out + inline-SVG chevron the\n// wizard fields use (`_inv-form.scss`) — that rule is scoped to `.inv-field`, so `.invkm-field`\n// needs its own copy. Padding-right clears the arrow.\n.invkm-field select.form-control {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 34px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23949699' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  cursor: pointer;\n}\n\n// Field message + hint. Deliberately NOT `.inv-error`/`.inv-hint` from `_inv-form.scss`: this page\n// never instantiates the wizard or edit component, and Angular only injects a component's styles\n// when it's on screen — so those globals simply don't exist here. Same trap `_ses-shared.scss`\n// and `_rep-shared.scss` were extracted for; the modal is small enough to just carry its own.\n.invkm-error { margin-top: 5px; font-size: 11.5px; line-height: 1.4; color: $implement-color; }\n.invkm-hint { margin: 5px 0 0; font-size: 11.5px; line-height: 1.4; color: $color-neutral-mid; }\n\n.invkm-req { color: $implement-color; }\n.invkm-readonly { background: $color-neutral-light !important; color: $color-neutral-mid; }\n\n// Transfer sits left, Purchase right on one row — the modal closes via the header × or the\n// overlay, so it carries no footer.\n.invkm-actions { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-top: 4px; }\n\n// The combobox menu is absolutely positioned inside `__body`, which scrolls — so the shared\n// 220px list overhangs the card and the last option gets clipped until you scroll the modal.\n// Shorter list inside modal chrome; it still scrolls internally past this many rows.\n.invkm .fsc__list { max-height: 170px; }\n\n.invkm-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &--primary { background: $develop-color; color: #fff; &:hover { background: darken($develop-color, 8%); } &[disabled] { opacity: 0.5; cursor: not-allowed; } }\n  &--purchase { background: $clarify-color; color: #fff; &:hover { background: darken($clarify-color, 8%); } }\n  &--ghost { background: none; color: $color-neutral-mid; border-color: transparent; &:hover { color: $body-content-color; } }\n}\n\n// Unlock-profiles modal (reuses .invkm chrome)\n.invkm__header-icon--unlock { background: $clarify-color; }\n\n// Reminder / message email modal (reuses .invkm chrome; wider card for email editing)\n.invkm__card--email { width: min(640px, 100%); }\n.invkm__header-icon--msg { background: $clarify-color; }\n.invdm-bar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; label { margin-bottom: 0; } }\n.invdm-tabs {\n  display: inline-flex; border: 1px solid $color-grey-1; border-radius: 6px; overflow: hidden; background: $color-neutral-light;\n}\n.invdm-tab {\n  display: inline-flex; align-items: center; gap: 5px; padding: 5px 12px; font-size: 12px; font-weight: 600;\n  font-family: $font-stack; color: $color-neutral-mid; background: none; border: none; cursor: pointer;\n  transition: all 0.15s ease;\n  & + & { border-left: 1px solid $color-grey-1; }\n  &:hover { color: $body-content-color; }\n  &.is-active { background: #fff; color: $clarify-color; }\n}\n.invdm-body { min-height: 260px; resize: vertical; font-size: 13px; line-height: 1.55; }\n.invdm-preview {\n  min-height: 260px; border: 1px solid $color-grey-1; border-radius: 6px; background: $color-neutral-light; overflow-y: auto;\n  &__subject { padding: 10px 14px; font-size: 13px; font-weight: 700; color: $color-neutral-dark; border-bottom: 1px solid $color-grey-1; background: #fff; }\n  pre {\n    margin: 0; padding: 12px 14px; font-family: $font-stack; font-size: 13px; line-height: 1.55;\n    color: $body-content-color; white-space: pre-wrap; word-break: break-word; background: none; border: none;\n  }\n}\n.invdm-invalid { border-color: $implement-color !important; }\n.invdm-error { margin-top: 6px; font-size: 12px; color: $implement-color; }\n.invum-summary {\n  border: 1px solid $color-grey-1; border-radius: 8px; overflow: hidden; margin-bottom: 14px;\n}\n.invum-row {\n  display: flex; justify-content: space-between; align-items: center; padding: 11px 14px; font-size: 13px; color: $body-content-color;\n  & + & { border-top: 1px solid $color-grey-1; }\n  &__val { font-weight: 700; color: $color-neutral-dark; }\n}\n.invum-warn {\n  display: flex; align-items: flex-start; gap: 8px; padding: 10px 12px; border-radius: 8px; font-size: 12.5px; line-height: 1.45;\n  background: rgba($ideate-color, 0.09); color: darken($ideate-color, 10%); border: 1px solid rgba($ideate-color, 0.28);\n  .fa { margin-top: 1px; }\n}\n\n// Tabs (clickable participant filters)\n.invd-tabs { display: flex; gap: 18px; align-items: center; flex-wrap: wrap; }\n.invd-tabs span { font-size: 13px; font-weight: 600; color: $color-neutral-mid; cursor: pointer; padding-bottom: 6px; transition: color 0.15s ease; }\n.invd-tabs span:hover { color: $body-content-color; }\n.invd-tabs .is-active { color: $clarify-color; border-bottom: 2px solid $clarify-color; }\n\n// Participants grid toolbar\n.invd-phead { flex-wrap: wrap; gap: 12px; }\n.invd-ptools { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n\n// Clean participants title with a count badge\n.invd-ptitle {\n  display: flex; align-items: center; gap: 8px; margin: 0;\n  font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;\n  color: $color-neutral-dark; font-family: $font-stack;\n}\n.invd-count {\n  display: inline-flex; align-items: center; justify-content: center; min-width: 22px; height: 20px; padding: 0 7px;\n  border-radius: 999px; background: $color-neutral-light; color: $color-neutral-mid; font-size: 12px; font-weight: 700; letter-spacing: 0;\n}\n\n// Square icon button (refresh) — aligns with the toolbar height\n.invd-iconbtn {\n  width: 34px; height: 34px; flex-shrink: 0; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff;\n  color: $color-neutral-mid; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; font-size: 14px;\n  transition: all 0.18s ease;\n  &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; color: $body-content-color; }\n  &.is-spinning i { animation: invd-spin 0.6s linear infinite; }\n}\n@keyframes invd-spin { to { transform: rotate(360deg); } }\n\n// Shared FourSight PDF Guides popup wrapper (hidden until opened) — same pattern as the profile view\n.guide-modal { display: none; }\n\n// Combined \"Download\" dropdown — single button with a select-style menu\n.invd-dl {\n  position: relative;\n  display: inline-flex;\n\n  &__caret { font-size: 11px; margin-left: 2px; transition: transform 0.15s ease; }\n  &.is-open &__caret { transform: rotate(180deg); }\n\n  &__backdrop { position: fixed; inset: 0; z-index: 40; }\n  &__menu {\n    position: absolute; top: calc(100% + 6px); left: 0; z-index: 50; min-width: 220px;\n    background: #fff; border: 1px solid $color-grey-1; border-radius: 8px;\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(0, 0, 0, 0.03);\n    padding: 6px; display: flex; flex-direction: column; gap: 2px;\n    &--right { left: auto; right: 0; }\n  }\n  &__item {\n    display: flex; align-items: center; gap: 10px; width: 100%; padding: 9px 12px;\n    border: none; background: none; border-radius: 6px; cursor: pointer;\n    font-size: 13px; font-weight: 600; font-family: $font-stack; color: $body-content-color;\n    text-align: left; transition: all 0.15s ease;\n    i { width: 16px; font-size: 13px; color: $clarify-color; }\n    &:hover { background: rgba($clarify-color, 0.08); color: $color-neutral-dark; }\n  }\n}\n.invd-psearch {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  i { position: absolute; left: 10px; color: $color-neutral-mid; font-size: 12px; pointer-events: none; }\n  input {\n    height: 34px;\n    box-sizing: border-box;\n    padding: 7px 10px 7px 28px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 12px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    outline: none;\n    min-width: 180px;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); }\n  }\n}\n\n// numeric score cells + locked-results indicator\n.invd-num { text-align: center; }\n.invd-muted { color: $color-neutral-mid; }\n.invd-lock {\n  width: 28px;\n  height: 22px;\n  border: none;\n  background: none;\n  color: $color-neutral-dark;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  transition: color 0.15s ease;\n  &:hover { color: $body-content-color; }\n}\n\n// participant row action buttons\n.invd-pactions { display: inline-flex; gap: 4px; align-items: center; }\n// Row actions — neutral grey at rest, each revealing its colour on hover.\n// Matches the invitations listing (.invl-actions__opr); state is carried by the\n// icon (e.g. bell vs bell-slash), never by rest colour alone.\n.invd-paction {\n  width: 26px;\n  height: 26px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  background: transparent;\n  color: #9aa0a6;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  transition: all 0.2s ease;\n\n  &:hover { background: $clarify-color; color: #fff; border-color: $clarify-color; transform: scale(1.08); }\n\n  &.is-remove {\n    font-size: 14px;\n    &:hover {\n      background: $implement-color; color: #fff; border-color: $implement-color;\n      box-shadow: 0 2px 8px rgba($implement-color, 0.3);\n    }\n  }\n  &.is-lock {\n    &:hover { background: #c77700; color: #fff; border-color: #c77700; }\n  }\n}\n\n// Started / not-started rows: a clear \"Remind\" CTA (matches the legacy)\n.invd-remind {\n  display: inline-flex; align-items: center; gap: 5px; height: 26px; padding: 0 11px;\n  border: 1px solid $develop-color; border-radius: 6px; background: $develop-color; color: #fff;\n  font-size: 12px; font-weight: 600; font-family: $font-stack; cursor: pointer; white-space: nowrap;\n  transition: all 0.15s ease;\n  i { font-size: 11px; }\n  &:hover { background: darken($develop-color, 8%); border-color: darken($develop-color, 8%); }\n}\n\n// participants pager\n.invd-ppager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid $color-grey-1;\n  flex-wrap: wrap;\n  &__info { font-size: 12px; color: $color-neutral-mid; }\n  &__ctrls { display: flex; gap: 4px; }\n  &__btn {\n    min-width: 28px;\n    height: 28px;\n    padding: 0 7px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    background: #fff;\n    color: $body-content-color;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    &:hover:not(:disabled):not(.is-active) { background: $color-neutral-light; border-color: $color-neutral-mid; }\n    &.is-active { background: $color-neutral-dark; color: #fff; border-color: $color-neutral-dark; }\n    &:disabled { opacity: 0.4; cursor: not-allowed; }\n  }\n}\n.invd-ppager__left { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }\n.invd-perpage {\n  display: inline-flex; align-items: center; gap: 6px; margin: 0; font-size: 12px; color: $color-neutral-mid;\n  select { padding: 4px 8px; border: 1px solid $color-grey-1; border-radius: 6px; font-size: 12px; color: $body-content-color; cursor: pointer; outline: none; }\n}\n\n// row selection + bulk actions\n.invd-check { width: 34px; text-align: center; }\n.invd-check input { cursor: pointer; margin: 0; }\n.invd-ptable tbody tr.is-selected { background: rgba($clarify-color, 0.06) !important; }\n.invd-bulk {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  background: rgba($clarify-color, 0.06);\n  border: 1px solid rgba($clarify-color, 0.2);\n  border-radius: 6px;\n  font-size: 13px;\n  &__count { font-weight: 600; color: $clarify-color; }\n  &__hint { font-weight: 500; color: $color-neutral-mid; }\n  // Download sits at the right edge of the bar, always available.\n  &__dl { margin-left: auto; }\n  .invd-btn { padding: 6px 12px; font-size: 12px; }\n\n  // Nothing selected: neutral chrome so it reads as a resting toolbar, not an active selection.\n  &.is-empty {\n    background: $color-neutral-light;\n    border-color: $color-grey-1;\n  }\n}\n// Same disabled treatment as .invd-progress / .invd-started-txt — was #ccc (1.6:1, invisible).\n.invd-locked-txt { display: inline-flex; align-items: center; gap: 5px; color: $color-neutral-mid-old; font-style: italic; i { font-size: 11px; } }\n\n// Participants table (Rosters treatment)\n.invd-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  thead tr { background: $color-neutral-light; }\n  thead th {\n    padding: 10px 14px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $color-neutral-dark;\n    border-bottom: 2px solid $color-grey-1;\n    text-align: left;\n    white-space: nowrap;\n  }\n  tbody tr {\n    border-bottom: 1px solid $color-grey-1;\n    transition: background-color 0.12s ease;\n    &:hover { background: rgba($clarify-color, 0.03); }\n    &:last-child { border-bottom: none; }\n  }\n  tbody td { padding: 10px 14px; font-size: 13px; color: $body-content-color; vertical-align: middle; }\n}\n.invd-empty { text-align: center; color: $color-neutral-mid; padding: 16px; font-size: 13px; }\n\n// participant state badges\n// Lock shown in each score column (cl/id/dv/im) for locked participants — dark grey, matching\n// the Graph-column lock and the \"Locked\" Profile label.\n.invd-num-lock { color: $color-neutral-dark; font-size: 11px; }\n\n// In-progress participants show \"N/36\" in the Profile column (the State column was removed).\n// Neutral grey — not colour-coded; tabular numerals keep the counts aligned.\n// Stand-ins shown where real data isn't available yet — a progress count instead of a profile\n// type, a stage word instead of a graph. They take the same muted-italic \"disabled\" treatment as\n// \"Locked\" (.invd-locked-txt) so the column reads as one family. Muted, but not the old #ccc:\n// that measured 1.6:1 and was effectively invisible; $color-neutral-mid-old is 3.2:1 — clearly\n// de-emphasised against the 5.1:1 body grey while still legible.\n.invd-progress {\n  font-size: 12px;\n  color: $color-neutral-mid-old;\n  font-style: italic;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.invd-started-txt {\n  font-size: 12px;\n  color: $color-neutral-mid-old;\n  font-style: italic;\n  white-space: nowrap;\n}\n\n// Stage filter chips with counts (easy filtering by participant stage)\n.invd-stagefilter { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin: 0 0 14px; }\n// \"Invite more\" sits on the left as a neutral pill action (not a primary CTA),\n// set off from the filter chips by a thin divider.\n.invd-stagefilter__sep { width: 1px; align-self: stretch; margin: 2px 2px; background: $color-grey-1; }\n.invd-invite {\n  display: inline-flex; align-items: center; gap: 6px; padding: 5px 12px;\n  border: 1px solid $color-grey-1; border-radius: 999px; background: #fff;\n  font-size: 12px; font-weight: 600; font-family: $font-stack; color: $body-content-color;\n  cursor: pointer; transition: all 0.15s ease;\n  i { font-size: 11px; color: $color-neutral-mid; }\n  &:hover { border-color: $color-neutral-mid; background: $color-neutral-light; }\n}\n.invd-chip {\n  display: inline-flex; align-items: center; gap: 6px; padding: 5px 10px;\n  border: 1px solid $color-grey-1; border-radius: 999px; background: #fff;\n  font-size: 12px; font-weight: 600; font-family: $font-stack; color: $color-neutral-mid;\n  cursor: pointer; transition: all 0.15s ease;\n  &__n {\n    display: inline-flex; align-items: center; justify-content: center; min-width: 18px; height: 18px; padding: 0 5px;\n    border-radius: 999px; background: $color-neutral-light; color: $color-neutral-mid; font-size: 11px; font-weight: 700;\n  }\n  &:hover { border-color: $color-neutral-mid; color: $body-content-color; }\n  &.is-active { background: $color-neutral-dark; border-color: $color-neutral-dark; color: #fff; .invd-chip__n { background: rgba(#fff, 0.22); color: #fff; } }\n  // Count badges are neutral grey for every stage (base .invd-chip__n) — not colour-coded.\n}\n\n// Divider between the details grid and the organizers list\n.invd-divider { height: 1px; background: $color-grey-1; margin: 18px 0 14px; }\n\n// Organizers as compact chips (inside the details card)\n.invd-orgs-title { display: block; margin-bottom: 10px; }\n.invd-orgs { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }\n\n.invd-org-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: $color-neutral-light;\n  border: 1px solid $color-grey-1;\n  border-radius: 999px;\n  padding: 3px 10px 3px 3px;\n  font-size: 12px;\n  color: $body-content-color;\n\n  .inv-avatar { width: 22px; height: 22px; font-size: 8px; }\n  &__name { font-weight: 500; white-space: nowrap; }\n  &__pending {\n    font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.03em;\n    color: #c77700; background: #fff4e5; border-radius: 999px; padding: 1px 7px; white-space: nowrap;\n  }\n  &__act {\n    border: none; background: none; color: $color-neutral-mid; cursor: pointer;\n    font-size: 12px; line-height: 1; padding: 0; display: inline-flex; align-items: center;\n    transition: color 0.15s ease;\n    &:hover { color: $clarify-color; }\n  }\n  &__remove {\n    border: none;\n    background: none;\n    color: $color-neutral-mid;\n    cursor: pointer;\n    font-size: 15px;\n    line-height: 1;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    transition: color 0.15s ease;\n    &:hover { color: $implement-color; }\n  }\n\n  // Invited but not yet approved\n  &.is-pending {\n    background: #fffaf2;\n    border-color: #ffd9a8;\n    border-style: dashed;\n  }\n}\n\n.invd-org-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba($clarify-color, 0.06);\n  border: 1px dashed rgba($clarify-color, 0.4);\n  color: $clarify-color;\n  border-radius: 999px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  &:hover { background: rgba($clarify-color, 0.12); border-style: solid; }\n}\n\n.invd-link { color: $clarify-color; cursor: pointer; font-size: 12px; font-weight: 600; display: inline-flex; align-items: center; gap: 4px; &:hover { text-decoration: underline; } }\n.invd-link--danger { color: $implement-color; }\n\n.invd-deferred { margin-top: 8px; font-size: 11px; color: #b0b4b8; border-top: 1px dashed #dde0e3; padding-top: 10px; }\n\n// ── Status pill colours + organizer avatars (cell visuals) ──\n.inv-pill { display: inline-flex; align-items: center; border-radius: 12px; padding: 4px 11px; font-size: 12px; font-weight: 700; border: none; }\n.inv-pill--open { background: rgba($develop-color, 0.12); color: darken($develop-color, 12%); }\n.inv-pill--closed { background: #f1f1f2; color: #8a9099; }\n\n.inv-avatar { display: inline-flex; width: 26px; height: 26px; border-radius: 50%; background: #00add0; color: #fff; align-items: center; justify-content: center; font-size: 9px; flex-shrink: 0; }\n// Organizer avatars use the same grey treatment as the Invitations listing.\n// Compound selectors so they beat the plain .inv-avatar base rule.\n.inv-avatar.inv-avatar--grey { background: $color-grey-1; color: $color-neutral-dark; }\n.inv-avatar.inv-avatar--grey-lighter { background: $color-neutral-light; color: $color-neutral-dark; }\n\n// \"Send Participant Email\" modal — App-style chrome matching the keys/edit modals\n.invem {\n  position: fixed; inset: 0; z-index: 100000; display: flex; align-items: flex-start; justify-content: center; padding: 50px 20px;\n  @media #{$mobile-up} { padding-left: 240px; }\n\n  &__overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); z-index: 0; }\n  &__card {\n    position: relative; z-index: 1; width: min(500px, 100%); max-height: calc(100vh - 100px);\n    display: flex; flex-direction: column; background: #fff; border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04); overflow: hidden;\n  }\n  &__header {\n    display: flex; align-items: center; gap: 12px; padding: 16px 20px;\n    background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n    border-bottom: 1px solid $color-grey-1;\n  }\n  &__header-icon { width: 36px; height: 36px; border-radius: 8px; background: $develop-color; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }\n  &__title { font-size: 15px; font-weight: 700; color: $color-neutral-dark; font-family: $font-stack; margin: 0; line-height: 1.3; }\n  &__subtitle { font-size: 12px; color: $body-content-color; margin: 2px 0 0; line-height: 1.3; opacity: 0.7; }\n  &__close {\n    margin-left: auto; width: 30px; height: 30px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff;\n    cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; color: $color-neutral-mid;\n    transition: all 0.15s ease; flex-shrink: 0;\n    &:hover { background: rgba($implement-color, 0.06); color: $implement-color; border-color: rgba($implement-color, 0.2); }\n  }\n  &__body {\n    padding: 20px; overflow-y: auto; font-size: 14px; line-height: 1.6; color: $body-content-color;\n    p { margin: 0 0 14px; }\n  }\n  &__intro { color: $color-neutral-mid; }\n  &__label { font-weight: 700; color: $color-neutral-dark; margin-bottom: 2px !important; }\n  &__val { margin-top: 0 !important; }\n  &__links {\n    margin: 0 0 14px; padding-left: 22px;\n    li { margin-bottom: 4px; }\n    a { color: $color-neutral-dark; text-decoration: underline; }\n    a:hover { color: $clarify-color; }\n  }\n  &__sign { margin-bottom: 0 !important; }\n  &__footer { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 20px; border-top: 1px solid $color-grey-1; }\n}\n\n// \"Get or send results\" modal — App-style chrome with language + delivery-mode options\n.invgr {\n  position: fixed; inset: 0; z-index: 100000; display: flex; align-items: flex-start; justify-content: center; padding: 50px 20px;\n  @media #{$mobile-up} { padding-left: 240px; }\n\n  &__overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); z-index: 0; }\n  &__card {\n    position: relative; z-index: 1; width: min(500px, 100%); max-height: calc(100vh - 100px);\n    display: flex; flex-direction: column; background: #fff; border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04); overflow: hidden;\n  }\n  &__header {\n    display: flex; align-items: center; gap: 12px; padding: 16px 20px;\n    background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n    border-bottom: 1px solid $color-grey-1;\n  }\n  &__header-icon { width: 36px; height: 36px; border-radius: 8px; background: $develop-color; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }\n  &__title { font-size: 15px; font-weight: 700; color: $color-neutral-dark; font-family: $font-stack; margin: 0; line-height: 1.3; }\n  &__subtitle { font-size: 12px; color: $body-content-color; margin: 2px 0 0; line-height: 1.3; opacity: 0.7; }\n  &__close {\n    margin-left: auto; width: 30px; height: 30px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff;\n    cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; color: $color-neutral-mid;\n    transition: all 0.15s ease; flex-shrink: 0;\n    &:hover { background: rgba($implement-color, 0.06); color: $implement-color; border-color: rgba($implement-color, 0.2); }\n  }\n  &__body { padding: 20px; overflow-y: auto; font-size: 14px; line-height: 1.5; color: $body-content-color; }\n  &__flabel { display: block; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: $color-neutral-dark; margin-bottom: 6px; }\n  .form-control {\n    width: 100%; padding: 9px 12px; font-size: 13px; border: 1px solid $color-grey-1; border-radius: 6px;\n    color: $body-content-color; background: #fff; outline: none; margin-bottom: 14px;\n    &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); }\n  }\n  &__note { margin: 0 0 10px; color: $color-neutral-mid; font-size: 13px; }\n  &__link { color: $clarify-color; cursor: pointer; text-decoration: underline; }\n  &__tip {\n    margin: 0 0 12px; padding: 12px 14px; border-radius: 8px; font-size: 13px; line-height: 1.5; color: $body-content-color;\n    background: rgba($clarify-color, 0.05); border: 1px solid rgba($clarify-color, 0.18);\n  }\n  &__tip-head {\n    display: flex; align-items: center; gap: 6px; font-weight: 700; color: darken($clarify-color, 12%); margin-bottom: 8px;\n    .fa { font-size: 14px; }\n  }\n  &__tip-steps {\n    margin: 0; padding-left: 18px;\n    li { margin-bottom: 6px; &:last-child { margin-bottom: 0; } }\n  }\n  &__tip-email {\n    display: inline-flex; align-items: center; gap: 5px; padding: 1px 7px; border-radius: 4px;\n    background: #fff; border: 1px solid rgba($clarify-color, 0.25); font-weight: 600; color: $color-neutral-dark; white-space: nowrap;\n  }\n  &__tip-copy {\n    color: $clarify-color; cursor: pointer; font-size: 11px; line-height: 1;\n    &:hover { color: darken($clarify-color, 10%); }\n  }\n  &__section { font-size: 14px; font-weight: 700; color: $color-neutral-dark; margin: 16px 0 8px; }\n  &__subnote { margin: 0 0 8px; color: $color-neutral-mid; font-size: 13px; }\n  &__radio {\n    display: flex; align-items: flex-start; gap: 8px; margin-bottom: 8px; font-size: 14px; color: $body-content-color; cursor: pointer;\n    input { margin: 3px 0 0; flex-shrink: 0; }\n  }\n  &__footer { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 20px; border-top: 1px solid $color-grey-1; align-items: center; }\n}\n\n// \"Invite more participants\" — 2-step email wizard modal\n.invwz {\n  position: fixed; inset: 0; z-index: 100000; display: flex; align-items: flex-start; justify-content: center; padding: 40px 20px;\n  @media #{$mobile-up} { padding-left: 240px; }\n\n  &__overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); z-index: 0; }\n  &__card {\n    position: relative; z-index: 1; width: min(680px, 100%); max-height: calc(100vh - 80px);\n    display: flex; flex-direction: column; background: #fff; border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04); overflow: hidden;\n  }\n  &__header {\n    display: flex; align-items: center; gap: 12px; padding: 16px 20px;\n    background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n    border-bottom: 1px solid $color-grey-1;\n  }\n  &__header-icon { width: 36px; height: 36px; border-radius: 8px; background: $develop-color; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }\n  &__title { font-size: 15px; font-weight: 700; color: $color-neutral-dark; font-family: $font-stack; margin: 0; line-height: 1.3; }\n  &__subtitle { font-size: 12px; color: $body-content-color; margin: 2px 0 0; line-height: 1.3; opacity: 0.7; }\n  &__close {\n    margin-left: auto; width: 30px; height: 30px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff;\n    cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; color: $color-neutral-mid;\n    transition: all 0.15s ease; flex-shrink: 0;\n    &:hover { background: rgba($implement-color, 0.06); color: $implement-color; border-color: rgba($implement-color, 0.2); }\n  }\n  &__body { padding: 20px; overflow-y: auto; }\n  &__footer { display: flex; justify-content: space-between; gap: 10px; padding: 12px 20px; border-top: 1px solid $color-grey-1; }\n\n  .form-control {\n    width: 100%; padding: 9px 12px; font-size: 13px; border: 1px solid $color-grey-1; border-radius: 6px;\n    color: $body-content-color; background: #fff; outline: none; font-family: $font-stack;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); }\n  }\n}\n\n// Stepper — compact inline with connector line (matches the create wizard)\n.invwz-steps { display: flex; list-style: none; padding: 0; margin: 0 0 18px; }\n.invwz-step {\n  display: flex; align-items: center; gap: 7px; flex: 1; min-width: 0;\n  color: $color-neutral-mid; font-size: 12px; font-weight: 600;\n\n  &:last-child { flex: 0 0 auto; }\n  // connector line running to the next step's circle\n  &::after { content: ''; flex: 1; height: 2px; min-width: 18px; margin: 0 12px; background: #eef0f1; border-radius: 2px; }\n  &:last-child::after { display: none; }\n  &.is-done::after { background: $develop-color; }\n\n  &__num {\n    width: 24px; height: 24px; border-radius: 50%; background: #eef0f1; color: $color-neutral-mid;\n    display: inline-flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; flex-shrink: 0; transition: background 0.15s ease;\n  }\n  &__label { white-space: nowrap; }\n  &.is-active { color: #1c84c6; }\n  &.is-active &__num { background: #1c84c6; color: #fff; }\n  &.is-done &__num { background: $develop-color; color: #fff; }\n}\n\n// Step content\n.invwz .invkm-field { margin-bottom: 12px; }\n.invwz-intro { font-size: 13px; color: $color-neutral-mid; margin: 0 0 14px; }\n.invwz-textarea { resize: vertical; line-height: 1.45; font-family: $font-stack; font-size: 12px; }\n.invwz-gen { margin-bottom: 4px; }\n.invwz-hint { font-size: 12px; color: $color-neutral-mid; margin: 0 0 12px; }\n.invwz-note { font-size: 13px; color: $body-content-color; margin: 0 0 8px; }\n.invwz-or { font-size: 13px; font-weight: 700; color: $color-neutral-mid; text-align: center; margin: 2px 0 10px; }\n.invwz-instr { margin: 0 0 14px; padding-left: 20px; font-size: 13px; color: $body-content-color; li { margin-bottom: 4px; } }\n.invwz-copyrow {\n  display: flex; align-items: flex-start; gap: 8px;\n  .form-control { flex: 1; }\n}\n.invwz-copybtn {\n  flex-shrink: 0; width: 36px; height: 36px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff;\n  color: $clarify-color; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px;\n  transition: all 0.15s ease;\n  &:hover { background: rgba($clarify-color, 0.08); border-color: rgba($clarify-color, 0.3); }\n}\n\n// ── Activity Groups inline board chrome, copied from session-board-page.component.scss ──\n// That component isn't mounted on /invitations/:id, so its `.sesb-*` rules (declared with\n// ViewEncapsulation.None) never make it into this page — same reasoning as the `.invkm` chrome\n// copy above. Duplicated verbatim (badge/button/download-dropdown) rather than shared, matching\n// the pattern the board page itself used for `.invkm`.\n.sesb-badge {\n  font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.4px;\n  padding: 3px 9px; border-radius: 20px;\n\n  &--split { background: rgba($clarify-color, 0.12); color: darken($clarify-color, 18%); }\n  &--active { background: rgba($develop-color, 0.12); color: darken($develop-color, 18%); }\n  &--expired { background: rgba($implement-color, 0.12); color: darken($implement-color, 12%); }\n}\n\n// Selection bar (move-to-group / download / clear) — appears when members are ticked.\n.sesb-selbar {\n  display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;\n  background: rgba($clarify-color, 0.06); border: 1px solid rgba($clarify-color, 0.28);\n  border-radius: 8px; padding: 8px 12px;\n  &__n { font-size: 13px; font-weight: 600; color: darken($clarify-color, 18%); margin-right: 4px; }\n}\n\n// Group-level selection bar. Same chrome as the participant one — they can be open together, so\n// the heavier left edge plus the \"N groups selected\" count is what tells them apart.\n.sesb-selbar--groups { border-left-width: 3px; }\n.sesb-movebox {\n  width: 200px;\n  .fsc__control { height: 34px; padding-top: 0; padding-bottom: 0; }\n}\n\n.sesb-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 14px;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  background: #fff;\n  color: $color-neutral-dark;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  line-height: 1;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s ease;\n\n  i { font-size: 12px; }\n  &:hover { background: $color-neutral-light; border-color: darken($color-grey-1, 6%); }\n\n  &--primary {\n    background: $develop-color; color: #fff; border-color: $develop-color;\n    &:hover { background: $color-dark-green; border-color: $color-dark-green; }\n  }\n\n  &--danger {\n    color: $implement-color; border-color: rgba($implement-color, 0.4);\n    &:hover { background: rgba($implement-color, 0.08); border-color: $implement-color; }\n  }\n\n  &--ghost {\n    border-color: transparent; background: transparent; color: $color-neutral-mid;\n    &:hover { background: $color-neutral-light; color: $color-neutral-dark; }\n  }\n\n  &:focus-visible { outline: 2px solid $develop-color; outline-offset: 1px; }\n}\n\n.sesb-dl {\n  position: relative;\n\n  &__caret { margin-left: 2px; font-size: 11px; }\n  &__backdrop { position: fixed; inset: 0; z-index: 10; }\n  &__menu {\n    position: absolute; top: calc(100% + 6px); left: 0; z-index: 11;\n    min-width: 200px; padding: 6px;\n    background: #fff; border: 1px solid $color-grey-1; border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  }\n  &__item {\n    display: flex; align-items: center; gap: 8px; width: 100%;\n    padding: 8px 10px; border: none; border-radius: 6px; background: transparent;\n    color: $color-neutral-dark; font-size: 13px; font-weight: 500; font-family: $font-stack;\n    text-align: left; cursor: pointer;\n    i { font-size: 12px; color: $color-neutral-mid; }\n    &:hover { background: $color-neutral-light; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
